export const rulesSearchCriteria = [
   {
      screen: 'RULES',
      config: [
         {
            sectionName: 'Data',
            sectionKey: '',
            categoryNumber: '',
            sectionForm: 'radioButton',
            fields: [
               {
                  inputType: 'radioButton',
                  radioButtonOptions: [
                     { key: 'Filed', field: 'filed' },
                     {
                        key: 'Historical',
                        field: 'history',
                     },
                  ],
               },
            ],
         },
         {
            sectionName: 'Record 2',
            sectionKey: 'record2s',
            fields: [
               {
                  field: 'ruleTariffNumber',
                  key: 'TAR',
                  fullName: 'Tariff Number',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'carrier_code',
                  key: 'CXR',
                  fullName: 'Carrier Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'categoryNumber',
                  key: 'CAT#',
                  fullName: 'Category Number',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'categoryNumber',
                  key: 'CAT NM',
                  fullName: 'Category Name',
                  inputType: 'multiSelect',
                  options: [
                     { label: 'Eligibility', value: '01' },
                     { label: 'Day Time', value: '02' },
                     { label: 'Seasons', value: '03' },
                     { label: 'Flight Application', value: '04' },
                     { label: 'Advance Purchase', value: '05' },
                     { label: 'Minimum Stay', value: '06' },
                     { label: 'Maximum Stay', value: '07' },
                     { label: 'Stopover', value: '08' },
                     { label: 'Transfers', value: '09' },
                     { label: 'Blackout', value: '11' },
                     { label: 'Surcharges', value: '12' },
                     { label: 'Accompanied Travel', value: '13' },
                     { label: 'Travel Restrictions', value: '14' },
                     { label: 'Sales Restrictions', value: '15' },
                     { label: 'Penalties', value: '16' },
                     { label: 'Higher Intermediate Points', value: '17' },
                     { label: 'Ticket Endorsements', value: '18' },
                     { label: 'Children Discounts', value: '19' },
                     { label: 'Tour Conductor Discount', value: '20' },
                     { label: 'Agent Discount', value: '21' },
                     { label: 'Other Discount', value: '22' },
                     { label: 'Miscellaneous Fare Tags', value: '23' },
                     { label: 'Groups', value: '26' },
                     { label: 'Tours', value: '27' },
                     { label: 'Visit Another Country', value: '28' },
                     { label: 'Deposits', value: '29' },
                     { label: 'Voluntary Changes', value: '31' },
                     { label: 'Voluntary Refunds', value: '33' },
                     { label: 'Negotiated Fare', value: '35' },
                     { label: 'Rule Application', value: '50' },
                  ],
               },
               {
                  field: 'sequenceNumber',
                  key: 'SEQUENCE',
                  fullName: 'Sequence Number',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'ruleNumber',
                  key: 'RULE',
                  fullName: 'Rule',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 4,
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'effectiveDate',
                  key: 'EFF DT',
                  fullName: 'Effective Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
               {
                  field: 'discontinueDate',
                  key: 'DISC DT',
                  fullName: 'Discontinue Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
               {
                  field: 'location1Type',
                  key: 'LOC1 TYPE',
                  fullName: 'Location 1 Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'LOC1',
                  fullName: 'Location 1',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'location2Type',
                  key: 'LOC2 TYPE',
                  fullName: 'Location 2 Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'LOC2',
                  fullName: 'Location 2',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'fareClassCode',
                  key: 'FBC',
                  fullName: 'Fare Class Code',
                  validationName: 'ALPHA_NUMERIC_WITH_ATPCO_WILD_CARDS',
                  characterLimit: 8,
                  placeHolder: 'AB%_,!&-',
                  inputType: 'text',
               },
               {
                  field: 'footnoteCode',
                  key: 'FT',
                  fullName: 'Footnote Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'roundTripIndicator',
                  key: 'OWRT',
                  fullName: 'OW/RT Indicator',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'routingNumber',
                  key: 'RTG',
                  fullName: 'Routing',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 4,
                  placeHolder: '1234',
                  inputType: 'text',
               },
               {
                  field: 'dayOfWeekType',
                  key: 'DOWT',
                  fullName: 'Day of Week Type Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'fareType',
                  key: 'TYP',
                  fullName: 'Fare Type Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'seasonType',
                  key: 'ST',
                  fullName: 'Season Type Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'generalRuleInd',
                  key: 'GENRULE',
                  fullName: 'General Rule Application',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'generalRuleNumber',
                  key: 'GRN',
                  fullName: 'General Rule Number',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'generalRuleTariffNumber',
                  key: 'GRT',
                  fullName: 'General Rule Tariff',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'applicationInd',
                  key: 'NOTAPPL',
                  fullName: 'Application Indicator',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'jointCarrier997Id',
                  key: 'JT CXR TBL',
                  fullName: 'Joint Carrier 997 ID',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'segmentCount',
                  key: 'SEGS',
                  fullName: 'Segment Count',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'actionCode',
                  key: 'ACT',
                  fullName: 'Action Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'batchCode',
                  key: 'BATCH CODE',
                  fullName: 'Batch Code',
                  validationName: 'ALPHA_NUMERIC',
                  characterLimit: 7,
                  dataType: 'string',
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'batchNumber',
                  key: 'BATCH NUMBER',
                  fullName: 'Batch Number',
                  validationName: 'NUMERIC',
                  characterLimit: 5,
                  dataType: 'string',
                  placeHolder: '12345',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
               {
                  field: 'product_type',
                  key: 'R TYPE',
                  fullName: 'Rule Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'footnoteStateCode',
                  key: 'S',
                  fullName: 'Footnote State Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  placeHolder: 'A1B2',
                  inputType: 'text',
                  disabled: true,
               },
               {
                  field: 'product_type',
                  key: 'DIST GRP',
                  fullName: 'Distribution Group',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  placeHolder: '123',
                  inputType: 'text',
                  disabled: true,
               },
               {
                  field: 'product_type',
                  key: 'CHG USER',
                  fullName: 'Change User',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  placeHolder: 'A1B2',
                  inputType: 'text',
                  disabled: true,
               },
               {
                  field: 'product_type',
                  key: 'CHG DT',
                  fullName: 'Change Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
                  disabled: true,
               },
            ],
         },
         {
            sectionName: 'Record 2 Segments',
            sectionKey: 'record2Segments',
            categoryNumber: '',
            fields: [
               {
                  field: 'relationalInd',
                  key: 'REL',
                  fullName: 'Relational Indicator',
                  validationName: 'SPECIAL_CHAR',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: '*',
                  inputType: 'text',
               },
               {
                  field: 'inOutboundInd',
                  key: 'IO',
                  fullName: 'Inbound/Outbound Indicator',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'directionalInd',
                  key: 'DIR',
                  fullName: 'Directional Indicator',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'categoryNumber',
                  key: 'CAT#',
                  fullName: 'Category Number',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'record3TableId',
                  key: 'REC3ID',
                  fullName: 'Rec3 Table ID',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'segmentNumber',
                  key: 'SEG',
                  fullName: 'Segment Number',
                  placeHolder: '123',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '01 - Eligibility',
            sectionKey: 'record3s',
            categoryNumber: '01',
            fields: [
               {
                  field: 'passengerTypeCode',
                  key: 'PTC',
                  fullName: 'Passenger Type Code',
                  characterLimit: 3,
                  placeHolder: 'ABC',
                  inputType: 'text',
               },
               {
                  field: 'maximumAge',
                  key: 'MAX AGE',
                  fullName: 'Maximum Age',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'minimumAge',
                  key: 'MIN AGE',
                  fullName: 'Minimum Age',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'passengerStatusCode',
                  key: 'PSC',
                  fullName: 'Passenger Status Code',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'accountCode',
                  key: 'AC',
                  fullName: 'Account Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 20,
                  placeHolder: 'A1B2C3...',
                  inputType: 'text',
               },
               {
                  field: 'applicationInd',
                  key: 'APP IND',
                  fullName: 'Application Indicator',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'firstOccurrence',
                  key: 'FIRST OCC',
                  fullName: 'First Occurrence',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'lastOccurrence',
                  key: 'LAST OCC',
                  fullName: 'Last Occurrence',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'idRequirementInd',
                  key: 'ID REQ IND',
                  fullName: 'Id Required Indicator',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'locationCode',
                  key: 'LOC CODE',
                  fullName: 'Location Code',
                  characterLimit: 3,
                  placeHolder: 'ABCDE',
                  inputType: 'text',
               },
               {
                  field: 'locationTypeCode',
                  key: 'LOC TYPE',
                  fullName: 'Location Type',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  dataType: 'string',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '02 - Day Time',
            sectionKey: 'record3s',
            categoryNumber: '02',
            fields: [
               {
                  field: 'daysOfWeek',
                  key: 'DOW',
                  fullName: 'Day of the Week',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'startTimeOfDay',
                  key: 'START TOD',
                  fullName: 'Start Time of day',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 4,
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'stopTimeOfDay',
                  key: 'STOP TOD',
                  fullName: 'Stop Time of day',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'timeApplicationCode',
                  key: 'TOD IND',
                  fullName: 'Time Application Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'returnDayOccurrence',
                  key: 'RET OCCUR',
                  fullName: 'Return Day Occurrence',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'returnSameDayInd',
                  key: 'RET IND',
                  fullName: 'Return ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'applicationTag',
                  key: 'APP IND',
                  fullName: 'Application Indicator',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'negateTag',
                  key: 'NEG IND',
                  fullName: 'Negate Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'geographic995Id',
                  key: 'GEO 995',
                  fullName: 'Geographic 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'locationType',
                  key: 'LOCTYP 995',
                  fullName: 'Geo Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'LOC1 995',
                  fullName: 'Geo Loc1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'LOC2 995',
                  fullName: 'Geo Loc2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'TSI 995',
                  fullName: 'Geo TSI Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '03 - Seasons',
            sectionKey: 'record3s',
            categoryNumber: '03',
            fields: [
               {
                  field: 'overrideInd',
                  key: 'OVR IND',
                  fullName: 'Override Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'seasonTypeCode',
                  key: 'SEA TYP',
                  fullName: 'Season Type code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'stopDate',
                  key: 'SEA ST',
                  fullName: 'Season Start Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'applicationInd',
                  key: 'SEA END',
                  fullName: 'Season End Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'geographic995Id',
                  key: 'GEO 995',
                  fullName: 'Geographic 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'locationType',
                  key: 'LOCTYP 995',
                  fullName: 'Geo Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'LOC1 995',
                  fullName: 'Geo Loc1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'LOC2 995',
                  fullName: 'Geo Loc2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'TSI 995',
                  fullName: 'Geo TSI Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '04 - Flight Application',
            sectionKey: 'record3s',
            categoryNumber: '04',
            fields: [
               {
                  field: 'applicationInd',
                  key: 'APP IND',
                  fullName: 'Application Indicator',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'flightNumber1',
                  key: 'FLIGHT NO 1',
                  fullName: 'Flight Number 1',
                  validationName: 'ALPHA_NUMERIC_WITH_STAR',
                  dataType: 'string',
                  characterLimit: 4,
                  placeHolder: 'QW1*',
                  inputType: 'text',
               },
               {
                  field: 'carrierCode1',
                  key: 'CXR CODE 1',
                  fullName: 'Carrier Code 1',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'carrier1FlightTable986Id',
                  key: 'CXR 1 986 ID',
                  fullName: 'Carrier Flight 1 986 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'carrierFlight986FlightNumber1',
                  key: 'FLT NO 1',
                  fullName: 'Flight Number 1',
                  validationName: 'ALPHA_NUMERIC_WITH_STAR',
                  dataType: 'string',
                  characterLimit: 4,
                  placeHolder: 'QW1*',
                  inputType: 'text',
               },
               {
                  field: 'carrierFlight986FlightNumber2',
                  key: 'FLT NO 2',
                  fullName: 'Flight Number 2',
                  validationName: 'ALPHA_NUMERIC_WITH_STAR',
                  dataType: 'string',
                  characterLimit: 4,
                  placeHolder: 'QW1*',
                  inputType: 'text',
               },
               {
                  field: 'carrierFlight986MarketingCarrier',
                  key: 'MKT CXR',
                  fullName: 'Marketing Carrier',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'carrierFlight986OperatingCarrier',
                  key: 'OP CXR',
                  fullName: 'Operating Carrier',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'relationalInd1',
                  key: 'REL IND 1',
                  fullName: 'Relational Ind 1',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'flightNumber2',
                  key: 'FLIGHT NO 2',
                  fullName: 'Flight Number 2',
                  validationName: 'ALPHA_NUMERIC_WITH_STAR',
                  dataType: 'string',
                  characterLimit: 4,
                  placeHolder: 'QW1*',
                  inputType: 'text',
               },
               {
                  field: 'carrierCode2',
                  key: 'CXR CODE 2',
                  fullName: 'Carrier Code 2',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'carrier2FlightTable986Id',
                  key: 'CXR 2 986 ID',
                  fullName: 'Carrier Flight 2 986 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'relationalInd2',
                  key: 'REL IND 2',
                  fullName: 'Relational Ind 2',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'flightNumber3',
                  key: 'FLIGHT NO 3',
                  fullName: 'Flight Number 3',
                  validationName: 'ALPHA_NUMERIC_WITH_STAR',
                  dataType: 'string',
                  characterLimit: 4,
                  placeHolder: 'QW1*',
                  inputType: 'text',
               },
               {
                  field: 'carrierCode3',
                  key: 'CXR CODE 3',
                  fullName: 'Carrier Code 3',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'dayOfWeekInds',
                  key: 'DOW IND',
                  fullName: 'Day Of Week Indicator',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 6,
                  placeHolder: 'A1B2C3',
                  inputType: 'text',
               },
               {
                  field: 'directionalInd',
                  key: 'DIR IND',
                  fullName: 'Directional Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'locationValidityInd',
                  key: 'LOC VAL IND',
                  fullName: 'Location Validity Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'locationCodeInd',
                  key: 'LOC CODE IND',
                  fullName: 'Location Code Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'viaInd',
                  key: 'VIA IND',
                  fullName: 'Via Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'hiddenInd',
                  key: 'HID IND',
                  fullName: 'Hidden Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'nonStopInd',
                  key: 'NON STOP IND',
                  fullName: 'Non Stop Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'directInd',
                  key: 'DIRECT IND',
                  fullName: 'Direct Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'multiStopInd',
                  key: 'MUL STOP IND',
                  fullName: 'Multi Stop Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'oneStopInd',
                  key: 'ONE STOP IND',
                  fullName: 'One Stop Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'onlineConnectInd',
                  key: 'ONLINE IND',
                  fullName: 'Online Connect Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'interlineConnectInd',
                  key: 'INTER IND',
                  fullName: 'Interline Connect Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'sameFlightInd',
                  key: 'SAME IND',
                  fullName: 'Same Flight Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'equipmentCodeInd',
                  key: 'EQP CODE IND',
                  fullName: 'Equipment Code Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'equipmentCode',
                  key: 'EQP CODE',
                  fullName: 'Equipment Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'andTable995Id',
                  key: 'AND GEO 995',
                  fullName: 'AND Geographic 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'locationType',
                  key: 'AND LOCTYP',
                  fullName: 'AND Geo Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'AND LOC1',
                  fullName: 'AND Geo Loc1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'AND LOC2',
                  fullName: 'AND Geo Loc2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'AND TSI',
                  fullName: 'AND Geo TSI Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'betweenTable995Id',
                  key: 'BET GEO 995',
                  fullName: 'Between Geographic 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'locationType',
                  key: 'BET LOCTYP',
                  fullName: 'Between Geo Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'BET LOC1',
                  fullName: 'Between Geo Loc1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'BET LOC2',
                  fullName: 'Between Geo Loc2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'BET TSI',
                  fullName: 'Between Geo TSI Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'viaTable995Id',
                  key: 'VIA GEO 995',
                  fullName: 'Via Geographic 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'locationType',
                  key: 'VIA LOCTYP',
                  fullName: 'Via Geo Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'VIA LOC1',
                  fullName: 'Via Geo Loc1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'VIA LOC2',
                  fullName: 'Via Geo Loc2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'VIA TSI',
                  fullName: 'Via Geo TSI Ind ',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '05 - Advance Purchase',
            sectionKey: 'record3s',
            categoryNumber: '05',
            fields: [
               {
                  field: 'firstTimeOfDay',
                  key: 'FIRST TOD',
                  fullName: 'First time of day',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 4,
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'firstPeriod',
                  key: 'FIRST P',
                  fullName: 'First Period',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'firstUnit',
                  key: 'FIRST U',
                  fullName: 'First Unit',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'lastTimeOfDay',
                  key: 'LAST TOD',
                  fullName: 'Last Time Of Day',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 4,
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'lastPeriod',
                  key: 'LAST P',
                  fullName: 'Last Period',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'lastUnit',
                  key: 'LAST U',
                  fullName: 'Last Unit',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'otherRestrictionIndicator',
                  key: 'OTH RES IND',
                  fullName: 'Other Reservation Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'immediateTicketingInd',
                  key: 'IMM TKT IND',
                  fullName: 'Immediate Tkt Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'notPermittedInd',
                  key: 'NOT PERM IND',
                  fullName: 'Not Permitted Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'waitListCode',
                  key: 'WAIT CODE',
                  fullName: 'Waitlist Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'segmentConfirmedCode',
                  key: 'SEG CODE',
                  fullName: 'Segment Confirm Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'eachSegmentInd',
                  key: 'EACH SEG IND',
                  fullName: 'Each Segment Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'ticketTimeOfDay',
                  key: 'TKT TOD',
                  fullName: 'Ticketing time of day',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 4,
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'ticketPeriod',
                  key: 'TKT P',
                  fullName: 'Ticket Period',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'ticketUnit',
                  key: 'TKT U',
                  fullName: 'Ticket Unit',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'departureOptionCode',
                  key: 'DEPART OP CODE',
                  fullName: 'Depart Option code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'timeBeforeDeparture',
                  key: 'TIME DEPART',
                  fullName: 'Time before Depart',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'departureUnit',
                  key: 'DEPART U',
                  fullName: 'Depart Unit',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'TSI',
                  fullName: 'Travel Segment Indicator',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'bothCode',
                  key: 'BOTH CODE',
                  fullName: 'Both Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'exceptionTime',
                  key: 'EXC TIME',
                  fullName: 'Exc Time',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'exceptionUnit',
                  key: 'EXC UNIT',
                  fullName: 'EXC Unit',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'reservationDate',
                  key: 'RES DATE',
                  fullName: 'Reservation Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
               {
                  field: 'ticketDate',
                  key: 'TKT DATE',
                  fullName: 'Ticket Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'geographic995Id',
                  key: 'GEO 995',
                  fullName: 'Geographic 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'locationType',
                  key: 'LOCTYP 995',
                  fullName: 'Geo Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'LOC1 995',
                  fullName: 'Geo Loc1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'LOC2 995',
                  fullName: 'Geo Loc2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'TSI 995',
                  fullName: 'Geo TSI Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '06 - Minimum Stay',
            sectionKey: 'record3s',
            categoryNumber: '06',
            fields: [
               {
                  field: 'minimumStayPeriod',
                  key: 'MIN STAY P',
                  fullName: 'Minimum Stay Period',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'minimumStayUnit',
                  key: 'MIN STAY U',
                  fullName: 'Minimum Stay Unit',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'dayOfWeekInds',
                  key: 'DOW IND',
                  fullName: 'Day Of Week Indicator',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 6,
                  placeHolder: 'A1B2C3',
                  inputType: 'text',
               },
               {
                  field: 'timeOfDay',
                  key: 'TOD',
                  fullName: 'Time Of day',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 4,
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'waiverCode',
                  key: 'WAV CODE',
                  fullName: 'Waiver Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'earlierLaterCode',
                  key: 'E/L CODE',
                  fullName: 'Earlier Later code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'minimumStayDate',
                  key: 'MIN STAY D',
                  fullName: 'Minimum Stay Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 6,
                  placeHolder: 'A1B2C3',
                  inputType: 'text',
               },
               {
                  field: 'waiverDate',
                  key: 'WAV DATE',
                  fullName: 'Waiver Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 6,
                  placeHolder: 'A1B2C3',
                  inputType: 'text',
               },
               {
                  field: 'waiverEarlierLaterCode',
                  key: 'WAV E/L',
                  fullName: 'Waiver Earlier Later Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'waiverPeriod',
                  key: 'WAV P',
                  fullName: 'Waiver Period',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'waiverUnit',
                  key: 'WAV U',
                  fullName: 'Waiver Unit',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'applicationCode',
                  key: 'APP CODE',
                  fullName: 'Application Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'greaterMileage',
                  key: 'G MIL',
                  fullName: 'Greater Mileage',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 4,
                  placeHolder: '1234',
                  inputType: 'text',
               },
               {
                  field: 'lesserMileage',
                  key: 'L MIL',
                  fullName: 'Lesser Mileage',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 4,
                  placeHolder: '1234',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'fromGeographic995Id',
                  key: 'FROM GEO 995',
                  fullName: 'From Geographic 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'locationType',
                  key: 'FROM LOCTYP 995',
                  fullName: 'From Geo Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'FROM LOC1 995',
                  fullName: 'From Geo Loc1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'FROM LOC2 995',
                  fullName: 'From Geo Loc2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'FROM TSI 995',
                  fullName: 'From Geo TSI Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'toGeographic995Id',
                  key: 'TO GEO 995',
                  fullName: 'To Geographic 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'locationType',
                  key: 'TO LOCTYP 995',
                  fullName: 'To Geo Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'TO LOC1 995',
                  fullName: 'To Geo Loc1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'TO LOC2 995',
                  fullName: 'To Geo Loc2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'TO TSI 995',
                  fullName: 'To Geo TSI Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '07 - Maximum Stay',
            sectionKey: 'record3s',
            categoryNumber: '07',
            fields: [
               {
                  field: 'maximumStayPeriod',
                  key: 'MAXSTAYP',
                  fullName: 'Maximum Stay Period',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'maximumStayUnit',
                  key: 'MAXSTAYU',
                  fullName: 'Maximum Stay Unit',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'returnTravelCode',
                  key: 'RET CODE',
                  fullName: 'Return Travel Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'timeOfDay',
                  key: 'TOD',
                  fullName: 'Time Of day',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 4,
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'ticketIssuanceInd',
                  key: 'TKT IND',
                  fullName: 'Ticketing Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'earlierLaterCode',
                  key: 'E/L CODE',
                  fullName: 'Earlier Later code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'maximumStayDate',
                  key: 'MAX STAY D',
                  fullName: 'Maximum Stay Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 6,
                  placeHolder: 'A1B2C3',
                  inputType: 'text',
               },
               {
                  field: 'waiverCode',
                  key: 'WAV CODE',
                  fullName: 'Waiver Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'waiverDate',
                  key: 'WAV DATE',
                  fullName: 'Waiver Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 6,
                  placeHolder: 'A1B2C3',
                  inputType: 'text',
               },
               {
                  field: 'waiverEarlierLaterCode',
                  key: 'WAV E/L',
                  fullName: 'Waiver Earlier Later Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'waiverPeriod',
                  key: 'WAV P',
                  fullName: 'Waiver Period',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'waiverUnit',
                  key: 'WAV U',
                  fullName: 'Waiver Unit',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'fromGeographic995Id',
                  key: 'FROM GEO 995',
                  fullName: 'From Geographic 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'locationType',
                  key: 'FROM LOCTYP 995',
                  fullName: 'From Geo Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'FROM LOC1 995',
                  fullName: 'From Geo Loc1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'FROM LOC2 995',
                  fullName: 'From Geo Loc2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'FROM TSI 995',
                  fullName: 'From Geo TSI Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'toGeographic995Id',
                  key: 'TO GEO 995',
                  fullName: 'To Geographic 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'locationType',
                  key: 'TO LOCTYP 995',
                  fullName: 'To Geo Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'TO LOC1 995',
                  fullName: 'To Geo Loc1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'TO LOC2 995',
                  fullName: 'To Geo Loc2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'TO TSI 995',
                  fullName: 'To Geo TSI Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '08 - Stopover',
            sectionKey: 'record3s',
            categoryNumber: '08',
            fields: [
               {
                  field: 'minimumNumber',
                  key: 'MIN NUM',
                  fullName: 'Minimum number',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'maximumNumber',
                  key: 'MAX NUM',
                  fullName: 'Maximum number',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'outboundNumber',
                  key: 'OUT NUM',
                  fullName: 'Outbound number',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'inboundNumber',
                  key: 'IN NUM',
                  fullName: 'Inbound Number',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'notBothInd',
                  key: 'NOT BOTH IND',
                  fullName: 'Not Both Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'openJawInd',
                  key: 'OPEN JAW',
                  fullName: 'Open Jaw Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'circleTrip2Ind',
                  key: 'CIRCLE TRIP',
                  fullName: 'Circle Trip Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'circleTrip2PlusInd',
                  key: 'CIRCLE T PL',
                  fullName: 'Circle Trip Plus Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'gatewayPermittedCode',
                  key: 'GATE PERM',
                  fullName: 'Gateway Permitted Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'minimumTimePeriod',
                  key: 'MIN TIME P',
                  fullName: 'Min Time Period',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'minimumTimeUnit',
                  key: 'MIN TIME U',
                  fullName: 'Min Time Unit',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'maximumTimePeriod',
                  key: 'MAX TIME P',
                  fullName: 'Max Time Period',
                  validationName: 'NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'maximumTimeUnit',
                  key: 'MAX TIME U',
                  fullName: 'Max Time Unit',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'samePointStopovers',
                  key: 'SAME STOP',
                  fullName: 'Same Points Stopovers',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'samePointTransits',
                  key: 'SAME TRANSITS',
                  fullName: 'Same Points Transits',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'samePointConnections',
                  key: 'SAME CONNECT',
                  fullName: 'Same Points Conn',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'application1Number',
                  key: 'APP 1 IND',
                  fullName: 'Application 1 Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'firstAmount1Code',
                  key: 'FIRST AMT NUM',
                  fullName: 'First Amount Stop Num',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'firstAmount1Int',
                  key: 'FIRST AMT',
                  fullName: 'First Amount',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'additionalAmount1Code',
                  key: 'ADD AMT 1 NUM',
                  fullName: 'Additional Amount 1 Stop Num',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'additionalAmount1Int',
                  key: 'ADD AMT 1',
                  fullName: 'Additional Amount 1',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'currency1Code',
                  key: 'CURR 1 CODE',
                  fullName: 'Currency 1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'decimalPlace1',
                  key: 'DEC 1 NO',
                  fullName: 'Decimal 1',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'firstAmount2Int',
                  key: 'FIRST AMT 2',
                  fullName: 'First Amount 2',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'additionalAmount2Int',
                  key: 'ADD AMT 2',
                  fullName: 'Additional Amount 2',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'currency2Code',
                  key: 'CURR 2 CODE',
                  fullName: 'Currency 2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'decimalPlace2',
                  key: 'DEC 2 NO',
                  fullName: 'Decimal 2',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'numberOfSegments',
                  key: 'SEG NUM',
                  fullName: 'Number of Segments',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'cat8SegSameCarrierCode',
                  key: 'SAME CXR CODE',
                  fullName: 'Same Carrier code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'cat8SegNumberOfStopover',
                  key: 'STOP NUM',
                  fullName: 'Number of Stopovers',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'cat8SegInboundCarrierCode',
                  key: 'IN CXR',
                  fullName: 'Inbound Carriers',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'cat8SegApplicationCode',
                  key: 'APP CODE',
                  fullName: 'Application Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'cat8SegLocationTypeCode',
                  key: 'LOC TYPE',
                  fullName: 'Location Type',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'cat8SegLocation1Code',
                  key: 'LOC 1 CODE',
                  fullName: 'Location 1 code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'cat8SegLocation2Code',
                  key: 'LOC 2 CODE',
                  fullName: 'Location 2 code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'cat8SegOutboundCarrierCode',
                  key: 'OUT CXR',
                  fullName: 'Outbound carrier code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'cat8SegInboundOutboundCode',
                  key: 'I/O',
                  fullName: 'I/O ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'cat8SegChargeCode',
                  key: 'CHARGE CODE',
                  fullName: 'Charge code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'gatewayTable995Id',
                  key: 'GEO 995',
                  fullName: 'Geographic 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'locationType',
                  key: 'LOCTYP 995',
                  fullName: 'Geo Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'LOC1 995',
                  fullName: 'Geo Loc1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'LOC2 995',
                  fullName: 'Geo Loc2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'TSI 995',
                  fullName: 'Geo TSI Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
               {
                  field: 'samePoints993Id',
                  key: 'POINT 993',
                  fullName: 'Same Points 993 ID',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '09 - Transfers',
            sectionKey: 'record3s',
            categoryNumber: '09',
            fields: [
               {
                  field: 'minNumberOfTransfers',
                  key: 'MIN',
                  fullName: 'Min number of transfer',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'maxNumberOfTransfers',
                  key: 'MAX',
                  fullName: 'Max number of transfer',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'prmTransferCode',
                  key: 'PRM',
                  fullName: 'Primary transfer code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'maxNumberOfPRMTransfers',
                  key: 'MAX PRM',
                  fullName: 'Max primary transfers',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'smeTransferCode',
                  key: 'SME',
                  fullName: 'Same carrier transfer code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'maxNumberOfSMETransfers',
                  key: 'MAX SME',
                  fullName: 'Max same transfer',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'interlineTransferCode',
                  key: 'INTERLINE',
                  fullName: 'Interline transfer code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'maxNumberOfInterlineTransfers',
                  key: 'MAX INTER',
                  fullName: 'Max interline transfer',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'otherCarrierTransferCode',
                  key: 'OTH CXR',
                  fullName: 'Other Carrier transfer code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'maxNumberOfOtherCarrierTransfers',
                  key: 'MAX OTH CXR',
                  fullName: 'Max other carrier transfer',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'outboundTransfersPermitted',
                  key: 'OUT',
                  fullName: 'Outbound Transfers',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'inboundTransfersPermitted',
                  key: 'IN',
                  fullName: 'Inbound Transfers',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'outboundOrReturnPermitCode',
                  key: 'OR',
                  fullName: 'Outbound return permit',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'surfTag',
                  key: 'SURF TAG',
                  fullName: 'Surface Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'surfTable976Id',
                  key: 'SURF 976 ID',
                  fullName: 'Surface table 976 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'embTag',
                  key: 'EMB TAG',
                  fullName: 'Embedded Surface Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'embeddedSurfTable976Id',
                  key: 'EMB 976 ID',
                  fullName: 'Embedded Table 976 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'transferChargesIndicator',
                  key: 'APPL',
                  fullName: 'Transfer Charges Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'maxTransfersAssessed',
                  key: 'CHARGE 1 NO',
                  fullName: 'Max Transfer Assess',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'charge1',
                  key: 'CHARGE 1 AMT',
                  fullName: 'Charge 1',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'maxTransfersCharged',
                  key: 'CHARGE 2 NO',
                  fullName: 'Max Transfer Charge',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'charge2',
                  key: 'CHARGE 2 AMT',
                  fullName: 'Charge 2',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'currencyCode1',
                  key: 'CURR 1',
                  fullName: 'Currency 1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'decimalPlace1',
                  key: 'DEC NO 1',
                  fullName: 'Decimal Place 1',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'charge3',
                  key: 'CHARGE 3 AMT',
                  fullName: 'Charge 3',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'charge4',
                  key: 'CHARGE 4 AMT',
                  fullName: 'Charge 4',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'currencyCode2',
                  key: 'CURR 2',
                  fullName: 'Currency 2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'decimalPlace2',
                  key: 'DEC NO 2',
                  fullName: 'Decimal Place 2',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'numberOfSegments',
                  key: 'NO OF SEGS',
                  fullName: 'No of Segments',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'cat9SegTransferApplication',
                  key: 'TRAN APPL',
                  fullName: 'Transfer Application',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'cat9SegTransferNumber',
                  key: 'NUM',
                  fullName: 'Transfer Number',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'cat9SegTransferPrm',
                  key: 'PRIMARY',
                  fullName: 'Transfer Primary',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'cat9SegTransferSme',
                  key: 'T SME',
                  fullName: 'Transfer Same Carrier',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'cat9SegTransferPrmOth',
                  key: 'T OTH CXR',
                  fullName: 'Transfer Other Carrier',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'cat9SegTransferInterline',
                  key: 'T INTERLINE',
                  fullName: 'Transfer Interline',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'cat9SegConnectionOrStopoverPoint',
                  key: 'CNX OR STOP',
                  fullName: 'Connection or Stopover',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'cat9SegCarrierApplicationCode',
                  key: 'CXR APP CODE',
                  fullName: 'Carrier App Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'cat9SegInCarrierCode',
                  key: 'IN CXR CODE',
                  fullName: 'In Carrier Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'cat9SegInCarrierTable990Id',
                  key: 'IN CXR 990 ID',
                  fullName: 'In carrier 990 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'cat9SegOutCarrierCode',
                  key: 'OUT CXR CODE',
                  fullName: 'Out Carrier Code',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'cat9SegOutCarrierTable990Id',
                  key: 'OUT CXR 990 ID',
                  fullName: 'Out carrier 990 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'cat9SegTravelSegmentIndicator',
                  key: 'TSI',
                  fullName: 'Travel Segment Indicator',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'cat9SegTypeCode',
                  key: 'TYPE CODE',
                  fullName: 'Type Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'cat9SegLocation1Code',
                  key: 'LOC 1 CODE',
                  fullName: 'Location 1 code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'cat9SegLocation2Code',
                  key: 'LOC 2 CODE',
                  fullName: 'Location 2 code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'cat9SegLocation1Zone978Id',
                  key: 'LOC 978 ID',
                  fullName: 'Location Zone 978 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'cat9SegBetween',
                  key: 'BET LOC',
                  fullName: 'Between Location',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'cat9SegGateway',
                  key: 'GATEWAY',
                  fullName: 'Gateway',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'cat9SegRestriction',
                  key: 'RESTRICTION',
                  fullName: 'Restriction',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'cat9SegPortionIndicator',
                  key: 'POR IND',
                  fullName: 'Portion Indicator',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'cat9SegTransferCharge',
                  key: 'TRANSFER',
                  fullName: 'Transfer Charge',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 11,
                  placeHolder: 'A1B2C3D4E5F',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '11 - Blackout',
            sectionKey: 'record3s',
            categoryNumber: '11',
            fields: [
               {
                  field: 'applicationInd',
                  key: 'APP IND',
                  fullName: 'Application Indicator',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'intConnectionInd',
                  key: 'INT CON WV',
                  fullName: 'International Conn Waiver',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'startDate',
                  key: 'BLACKOUT ST',
                  fullName: 'Blackout Start Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'stopDate',
                  key: 'BLACKOUT END',
                  fullName: 'Blackout End Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'andTable995Id',
                  key: 'AND GEO 995',
                  fullName: 'AND Geographic 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'AND LOCTYP 995',
                  fullName: 'AND Geo Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'AND LOC1 995',
                  fullName: 'AND Geo Loc1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'AND LOC2 995',
                  fullName: 'AND Geo Loc2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'AND TSI 995',
                  fullName: 'AND Geo TSI Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'betweenTable995Id',
                  key: 'BET GEO 995',
                  fullName: 'Between Geographic 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'locationType',
                  key: 'BET LOCTYP 995',
                  fullName: 'Between Geo Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'BET LOC1 995',
                  fullName: 'Between Geo Loc1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'BET LOC2 995',
                  fullName: 'Between Geo Loc2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'BET TSI 995',
                  fullName: 'Between Geo TSI Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '12 - Surcharges',
            sectionKey: 'record3s',
            categoryNumber: '12',
            fields: [
               {
                  field: 'startPeriod',
                  key: 'START P',
                  fullName: 'Start Period',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 6,
                  placeHolder: 'A1B2C3',
                  inputType: 'text',
               },
               {
                  field: 'stopPeriod',
                  key: 'STOP P',
                  fullName: 'Stop Period',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 6,
                  placeHolder: 'A1B2C3',
                  inputType: 'text',
               },
               {
                  field: 'firstTimeOfDay',
                  key: 'FIRST TOD',
                  fullName: 'First time of day',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 4,
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'lastTimeOfDay',
                  key: 'LAST TOD',
                  fullName: 'Last Time Of Day',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 4,
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'timeOfDayApplicationInd',
                  key: 'TOD APP IND',
                  fullName: 'Time Of Day App Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'dayOfWeekInds',
                  key: 'DOW IND',
                  fullName: 'Day Of Week Indicator',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 6,
                  placeHolder: 'A1B2C3',
                  inputType: 'text',
               },
               {
                  field: 'surchargeType',
                  key: 'SUR TYPE',
                  fullName: 'Surcharge Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'equipmentCode',
                  key: 'EQP CODE',
                  fullName: 'Equipment Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'travelPortionInd',
                  key: 'TVL POR IND',
                  fullName: 'Travel Portion Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'sectorPortionInd',
                  key: 'SEC POR IND',
                  fullName: 'Sector Portion Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'applicationCode',
                  key: 'APP CODE',
                  fullName: 'Application Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'surcharge1Amount',
                  key: 'SUR 1 AMT',
                  fullName: 'Surcharge 1 Amount',
                  validationName: 'AMOUNT',
                  dataType: 'number',
                  placeHolder: '100',
                  inputType: 'text',
               },
               {
                  field: 'currency1Code',
                  key: 'CURR 1 CODE',
                  fullName: 'Currency 1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'surcharge2Amount',
                  key: 'SUR 2 AMT',
                  fullName: 'Surcharge 2 Amount',
                  validationName: 'AMOUNT',
                  dataType: 'number',
                  placeHolder: '100',
                  inputType: 'text',
               },
               {
                  field: 'currency2Code',
                  key: 'CURR 2 CODE',
                  fullName: 'Currency 2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'percent',
                  key: 'PERCENT',
                  fullName: 'percent',
                  validationName: 'AMOUNT',
                  dataType: 'number',
                  placeHolder: '100',
                  inputType: 'text',
               },
               {
                  field: 'percentApplicationCode',
                  key: 'PER APP CODE',
                  fullName: 'Percent Application Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'reservationBookingDesignator',
                  key: 'RBD',
                  fullName: 'RBD',
                  characterLimit: 1,
                  placeHolder: 'Q',
                  inputType: 'text',
               },
               {
                  field: 'carrierFlight986Id',
                  key: 'FLIGHT 986 ID',
                  fullName: 'Carrier Flight 986 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'carrierFlight986FlightNumber1',
                  key: 'FLT NO 1',
                  fullName: 'Flight Number 1',
                  validationName: 'ALPHA_NUMERIC_WITH_STAR',
                  dataType: 'string',
                  characterLimit: 4,
                  placeHolder: 'QW1*',
                  inputType: 'text',
               },
               {
                  field: 'carrierFlight986FlightNumber2',
                  key: 'FLT NO 2',
                  fullName: 'Flight Number 2',
                  validationName: 'ALPHA_NUMERIC_WITH_STAR',
                  dataType: 'string',
                  characterLimit: 4,
                  placeHolder: 'QW1*',
                  inputType: 'text',
               },
               {
                  field: 'carrierFlight986MarketingCarrier',
                  key: 'MKT CXR',
                  fullName: 'Marketing Carrier',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'carrierFlight986OperatingCarrier',
                  key: 'OP CXR',
                  fullName: 'Operating Carrier',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'geographic995Id',
                  key: 'FROM GEO 995',
                  fullName: 'From Geographic 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'locationType',
                  key: 'FROM LOCTYP',
                  fullName: 'From Geo Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'FROM LOC1',
                  fullName: 'From Geo Loc1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'FROM LOC2',
                  fullName: 'From Geo Loc2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'FROM TSI',
                  fullName: 'From Geo TSI Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'betweenTable995Id',
                  key: 'BET GEO 995',
                  fullName: 'Between Geographic 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'locationType',
                  key: 'BET LOCTYP',
                  fullName: 'Between Geo Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'BET LOC1 995',
                  fullName: 'Between Geo Loc1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'BET LOC2',
                  fullName: 'Between Geo Loc2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'BET TSI',
                  fullName: 'Between Geo TSI Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'andTable995Id',
                  key: 'AND GEO 995',
                  fullName: 'AND Geographic 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'locationType',
                  key: 'AND LOCTYP',
                  fullName: 'AND Geo Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'AND LOC1',
                  fullName: 'AND Geo Loc1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'AND LOC2',
                  fullName: 'AND Geo Loc2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'AND TSI',
                  fullName: 'AND Geo TSI Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '13 - Accompanied Travel',
            sectionKey: 'record3s',
            categoryNumber: '13',
            fields: [
               {
                  field: 'allSectorsInd',
                  key: 'ALL SEC IND',
                  fullName: 'All Sectors Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'outboundJourneyInd',
                  key: 'OUT JRNY IND',
                  fullName: 'Outbound Journey Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'atLeastOneSectorInd',
                  key: 'ONE SEC IND',
                  fullName: 'Atleast One Sector Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'sameCompartmentInd',
                  key: 'SAME COM IND',
                  fullName: 'Same Compartment Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'sameRuleInd',
                  key: 'SAME RUL IND',
                  fullName: 'Same Rule Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'accompanyingPassengerInd',
                  key: 'ACC PASS IND',
                  fullName: 'Accompany Passenger Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'passengerTypeCode',
                  key: 'PTC',
                  fullName: 'Passenger Type Code',
                  characterLimit: 3,
                  placeHolder: 'ABC',
                  inputType: 'text',
               },
               {
                  field: 'idRequirementInd',
                  key: 'ID REQ IND',
                  fullName: 'Id Required Indicator',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'minimumAge',
                  key: 'MIN AGE',
                  fullName: 'Minimum Age',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'maximumAge',
                  key: 'MAX AGE',
                  fullName: 'Maximum Age',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'minimumNumber',
                  key: 'MIN NUM',
                  fullName: 'Minimum number',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'maximumNumber',
                  key: 'MAX NUM',
                  fullName: 'Maximum number',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'fareBookingInd',
                  key: 'FARE BOOK',
                  fullName: 'Fare Booking Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'numberOfSegments',
                  key: 'SEG NUM',
                  fullName: 'Number of Segments',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'cat13SegFareClassBookingCode',
                  key: 'FBC',
                  fullName: 'Fare Class Code',
                  validationName: 'ALPHA_NUMERIC_WITH_ATPCO_WILD_CARDS',
                  characterLimit: 8,
                  placeHolder: 'AB%_,!&-',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '14 - Travel Restrictions',
            sectionKey: 'record3s',
            categoryNumber: '14',
            fields: [
               {
                  field: 'commenceFromDate',
                  key: 'TVL ST',
                  fullName: 'Travel Start Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'commenceToDate',
                  key: 'TVL END',
                  fullName: 'Travel End Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'completeDate',
                  key: 'TVL CMPLT',
                  fullName: 'Travel Complete Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'completeInd',
                  key: 'RI',
                  fullName: 'Return Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'geographic995Id',
                  key: 'GEO 995',
                  fullName: 'Geographic 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'locationType',
                  key: 'LOCTYP 995',
                  fullName: 'Geo Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'LOC1 995',
                  fullName: 'Geo Loc1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'LOC2 995',
                  fullName: 'Geo Loc2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'TSI 995',
                  fullName: 'Geo TSI Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'timeOfDay',
                  key: 'RET TM',
                  fullName: 'Return Time Of Day',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 4,
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '15 - Sales Restrictions',
            sectionKey: 'record3s',
            categoryNumber: '15',
            fields: [
               {
                  field: 'ticketingFromDate',
                  key: 'FST TKT',
                  fullName: 'First Ticketing Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'ticketingToDate',
                  key: 'LST TKT',
                  fullName: 'Last Ticketing Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationFromDate',
                  key: 'FST RES',
                  fullName: 'First Reservation Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationToDate',
                  key: 'LST RES',
                  fullName: 'Last Reservation Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'cat15SegLocationTypeCode',
                  key: 'LOCTYP',
                  fullName: 'Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'cat15SegLocation1Code',
                  key: 'LOC1',
                  fullName: 'Location 1',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'cat15SegLocation2Code',
                  key: 'LOC2',
                  fullName: 'Location 2',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '16 - Penalties',
            sectionKey: 'record3s',
            categoryNumber: '16',
            fields: [
               {
                  field: 'voluntaryInd',
                  key: 'VOL IND',
                  fullName: 'Voluntary Changes',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'involuntaryInd',
                  key: 'INVOL IND',
                  fullName: 'Involuntary Changes',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'cancellationsInd',
                  key: 'CAN REF',
                  fullName: 'Cancellation and Refunds',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'ticketRefundCode',
                  key: 'TKT REF',
                  fullName: 'Ticket Refund Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'cancelInd',
                  key: 'CAN IND',
                  fullName: 'Cancellation Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'failureInd',
                  key: 'FAIL IND',
                  fullName: 'Failure Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'reissueInd',
                  key: 'REISSUE IND',
                  fullName: 'Reissue Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'replaceInd',
                  key: 'REPLACE IND',
                  fullName: 'Replace Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'changeInd',
                  key: 'CHANGE IND',
                  fullName: 'Change Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'ptaInd',
                  key: 'PTA IND',
                  fullName: 'PTA Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'refundInd',
                  key: 'REFUND IND',
                  fullName: 'Refund Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 11,
                  placeHolder: 'A1B2C3D4E5F',
                  inputType: 'text',
               },
               {
                  field: 'applicationCode',
                  key: 'APP CODE',
                  fullName: 'Application Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'portionCode',
                  key: 'POR CODE',
                  fullName: 'Portion code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'penalty1Amount',
                  key: 'PENALTY 1 AMT',
                  fullName: 'Penalty 1 Amount',
                  validationName: 'NUMERIC',
                  dataType: 'string',
                  characterLimit: 9,
                  placeHolder: '1.5',
                  inputType: 'text',
               },
               {
                  field: 'currency1Code',
                  key: 'CURR 1 CODE',
                  fullName: 'Currency 1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'penalty2Amount',
                  key: 'PENALTY 2 AMT',
                  fullName: 'Penalty 2 Amount',
                  validationName: 'AMOUNT',
                  dataType: 'number',
                  placeHolder: '10.0',
                  inputType: 'text',
               },
               {
                  field: 'currency2Code',
                  key: 'CURR 2 CODE',
                  fullName: 'Currency 2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'percent',
                  key: 'PERCENT',
                  fullName: 'percent',
                  validationName: 'AMOUNT',
                  dataType: 'number',
                  placeHolder: '10.0',
                  inputType: 'text',
               },
               {
                  field: 'highLowCode',
                  key: 'H/L IND',
                  fullName: 'High Low Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'deathInd',
                  key: 'DEA WAV IND',
                  fullName: 'Death Waiver Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'illnessInd',
                  key: 'ILL WAV IND',
                  fullName: 'Illness Waiver Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'familyDeathInd',
                  key: 'F DEA WAV IND',
                  fullName: 'Family Death Waiver',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'familyIllnessInd',
                  key: 'F ILL WAV IND',
                  fullName: 'Family Illness Waiver',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'scheduleChangeInd',
                  key: 'SCH C IND',
                  fullName: 'Schedule Change Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'ticketUpgradeInd',
                  key: 'TKT UG IND',
                  fullName: 'Ticket Upgrade Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'geographic995Id',
                  key: 'GEO 995',
                  fullName: 'Geographic 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'locationType',
                  key: 'LOCTYP 995',
                  fullName: 'Geo Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'LOC1 995',
                  fullName: 'Geo Loc1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'LOC2 995',
                  fullName: 'Geo Loc2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'TSI 995',
                  fullName: 'Geo TSI Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '17 - Higher Intermediate Points',
            sectionKey: 'record3s',
            categoryNumber: '17',
            fields: [
               {
                  field: 'locationTypeCode',
                  key: 'LOC TYPE CODE',
                  fullName: 'Location Type Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'LOC 1 CODE',
                  fullName: 'Location 1 code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'LOC 2 CODE',
                  fullName: 'Location 2 code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'connectionOrStopOverPoint',
                  key: 'CXN STOP',
                  fullName: 'Connection or Stopover',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'noHipCode',
                  key: 'NO HIP',
                  fullName: 'No Higher Intermediate',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '18 - Ticket Endorsements',
            sectionKey: 'record3s',
            categoryNumber: '18',
            fields: [
               {
                  field: 'text',
                  key: 'TICKET TEXT',
                  fullName: 'Ticket Text',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'locationCode',
                  key: 'LOC CODE',
                  fullName: 'Location Code',
                  characterLimit: 3,
                  placeHolder: 'ABCDE',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '19 - Children Discounts',
            sectionKey: 'record3s',
            categoryNumber: '19',
            fields: [
               {
                  field: 'noDiscountInd',
                  key: 'NO DISC IND',
                  fullName: 'No Discount Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'passengerTypeCode',
                  key: 'PTC',
                  fullName: 'Passenger Type Code',
                  characterLimit: 3,
                  placeHolder: 'ABC',
                  inputType: 'text',
               },
               {
                  field: 'idRequirementInd',
                  key: 'ID REQ IND',
                  fullName: 'Id Required Indicator',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'minimumAge',
                  key: 'MIN AGE',
                  fullName: 'Minimum Age',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'maximumAge',
                  key: 'MAX AGE',
                  fullName: 'Maximum Age',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'firstTravelOccurrence',
                  key: 'FIRST TVL',
                  fullName: 'First travel occur',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'lastTravelOccurrence',
                  key: 'LAST TVL',
                  fullName: 'Last travel occur',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'fareInd',
                  key: 'FARE IND',
                  fullName: 'Fare Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'percentApplication',
                  key: 'PERCENT APP',
                  fullName: 'Percent Application',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'owRtInd',
                  key: 'OWRT',
                  fullName: 'OW/RT Indicator',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'baseFareType',
                  key: 'FARE TYPE',
                  fullName: 'Base Fare Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'baseFareApplication',
                  key: 'FARE APP',
                  fullName: 'Base Fare App',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'bookingApplicationInd',
                  key: 'BOOK APP IND',
                  fullName: 'Booking App Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'bookingCode',
                  key: 'BOOK CODE',
                  fullName: 'Booking Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'betweenCityCode',
                  key: 'BET CITY CODE',
                  fullName: 'Between City Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'andCityCode',
                  key: 'AND CITY CODE',
                  fullName: 'AND City Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'specifiedFare1',
                  key: 'SPEC FARE 1',
                  fullName: 'Specified Fare 1',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'currency1Code',
                  key: 'CURR 1',
                  fullName: 'Currency 1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'decimal1Number',
                  key: 'DEC 1',
                  fullName: 'Decimal 1',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'specifiedFare2',
                  key: 'SPEC FARE 2',
                  fullName: 'Specified Fare 2',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'currency2Code',
                  key: 'CURR 2',
                  fullName: 'Currency 2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'decimal2Number',
                  key: 'DEC 2',
                  fullName: 'Decimal 2',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'resultingOwRtInd',
                  key: 'RES OWRT',
                  fullName: 'Resulting OwRt',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'resultingFareClass',
                  key: 'RES FCC',
                  fullName: 'Resulting Fare Class',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'resultingBookingCode',
                  key: 'RES BC',
                  fullName: 'Resulting Booking Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'ticketingCode',
                  key: 'TKT CODE',
                  fullName: 'Ticketing Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 10,
                  placeHolder: 'A1B2C3D4E5',
                  inputType: 'text',
               },
               {
                  field: 'ticketingCodeModifier',
                  key: 'TKT CODE MOD',
                  fullName: 'Ticketing Code Modifier',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'ticketDesignator',
                  key: 'TKT DES',
                  fullName: 'Ticket Designator',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 10,
                  placeHolder: 'A1B2C3D4E5',
                  inputType: 'text',
               },
               {
                  field: 'ticketDesignatorModifier',
                  key: 'TKT DES MOD',
                  fullName: 'Ticket designator modifier',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'allSectorsInd',
                  key: 'ALL SEC IND',
                  fullName: 'All Sectors Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'outboundJourneyInd',
                  key: 'OUT IND',
                  fullName: 'Outboud Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'atLeastOneSectorInd',
                  key: 'ONE SEC IND',
                  fullName: 'Atleast One Sector Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'sameCompartmentInd',
                  key: 'SAME COMP',
                  fullName: 'Same Compartment',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'sameRuleInd',
                  key: 'SAME RULE',
                  fullName: 'Same Rule Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'accompanyingPassengerInd',
                  key: 'ACC PASS',
                  fullName: 'Acc Passenger',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'fareBookingInd',
                  key: 'FARE BOOK IND',
                  fullName: 'Fare Booking Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'endOfRecordInd',
                  key: 'EOD',
                  fullName: 'End Of Record',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'noOfSegments',
                  key: 'NO OF SEG',
                  fullName: 'No Of Segments',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'cat19SegMinNumber',
                  key: 'S. MIN NO PASS',
                  fullName: 'Segment Min No of Passenger',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'cat19SegMaxNumber',
                  key: 'S. MAX NO PASS',
                  fullName: 'Segment Max No of Passenger',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'cat19SegPassengerTypeCode',
                  key: 'S. PTC',
                  fullName: 'Segment Passenger Type Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'cat19SegMaxAge',
                  key: 'S. MAX AGE',
                  fullName: 'Segment Maximum age',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'cat19SegMinAge',
                  key: 'S. MIN AGE',
                  fullName: 'Segment Minimum Age',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'cat19SegFareClassCode',
                  key: 'S. FCC',
                  fullName: 'Segment Fare Class Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'geographic995Id',
                  key: 'GEO 995',
                  fullName: 'Geographic 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'locationType',
                  key: 'LOCTYP 995',
                  fullName: 'Geo Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'LOC1 995',
                  fullName: 'Geo Loc1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'LOC2 995',
                  fullName: 'Geo Loc2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'TSI 995',
                  fullName: 'Geo TSI Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '20 - Tour Conductor Discount',
            sectionKey: 'record3s',
            categoryNumber: '20',
            fields: [
               {
                  field: 'noDiscountInd',
                  key: 'NO DISC IND',
                  fullName: 'No Discount Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'passengerTypeCode',
                  key: 'PTC',
                  fullName: 'Passenger Type Code',
                  characterLimit: 3,
                  placeHolder: 'ABC',
                  inputType: 'text',
               },
               {
                  field: 'idRequirementInd',
                  key: 'ID REQ IND',
                  fullName: 'Id Required Indicator',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'minimumAge',
                  key: 'MIN AGE',
                  fullName: 'Minimum Age',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'maximumAge',
                  key: 'MAX AGE',
                  fullName: 'Maximum Age',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'firstTravelOccurrence',
                  key: 'FIRST TVL',
                  fullName: 'First travel occur',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'lastTravelOccurrence',
                  key: 'LAST TVL',
                  fullName: 'Last travel occur',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'fareInd',
                  key: 'FARE IND',
                  fullName: 'Fare Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'percentApplication',
                  key: 'PERCENT APP',
                  fullName: 'Percent Application',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'owRtInd',
                  key: 'OWRT',
                  fullName: 'OW/RT Indicator',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'baseFareType',
                  key: 'FARE TYPE',
                  fullName: 'Base Fare Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'baseFareApplication',
                  key: 'FARE APP',
                  fullName: 'Base Fare App',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'bookingApplicationInd',
                  key: 'BOOK APP IND',
                  fullName: 'Booking App Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'bookingCode',
                  key: 'BOOK CODE',
                  fullName: 'Booking Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'betweenCityCode',
                  key: 'BET CITY CODE',
                  fullName: 'Between City Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'andCityCode',
                  key: 'AND CITY CODE',
                  fullName: 'AND City Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'specifiedFare1',
                  key: 'SPEC FARE 1',
                  fullName: 'Specified Fare 1',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'currency1Code',
                  key: 'CURR 1',
                  fullName: 'Currency 1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'decimal1Number',
                  key: 'DEC 1',
                  fullName: 'Decimal 1',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'specifiedFare2',
                  key: 'SPEC FARE 2',
                  fullName: 'Specified Fare 2',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'currency2Code',
                  key: 'CURR 2',
                  fullName: 'Currency 2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'decimal2Number',
                  key: 'DEC 2',
                  fullName: 'Decimal 2',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'resultingOwRtInd',
                  key: 'RES OWRT',
                  fullName: 'Resulting OwRt',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'resultingFareClass',
                  key: 'RES FCC',
                  fullName: 'Resulting Fare Class',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'resultingBookingCode',
                  key: 'RES BC',
                  fullName: 'Resulting Booking Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'ticketingCode',
                  key: 'TKT CODE',
                  fullName: 'Ticketing Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 10,
                  placeHolder: 'A1B2C3D4E5',
                  inputType: 'text',
               },
               {
                  field: 'ticketingCodeModifier',
                  key: 'TKT CODE MOD',
                  fullName: 'Ticketing Code Modifier',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'ticketDesignator',
                  key: 'TKT DES',
                  fullName: 'Ticket Designator',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 10,
                  placeHolder: 'A1B2C3D4E5',
                  inputType: 'text',
               },
               {
                  field: 'ticketDesignatorModifier',
                  key: 'TKT DES MOD',
                  fullName: 'Ticket designator modifier',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'allSectorsInd',
                  key: 'ALL SEC IND',
                  fullName: 'All Sectors Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'outboundJourneyInd',
                  key: 'OUT IND',
                  fullName: 'Outboud Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'atLeastOneSectorInd',
                  key: 'ONE SEC IND',
                  fullName: 'Atleast One Sector Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'sameCompartmentInd',
                  key: 'SAME COMP',
                  fullName: 'Same Compartment',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'sameRuleInd',
                  key: 'SAME RULE',
                  fullName: 'Same Rule Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'accompanyingPassengerInd',
                  key: 'ACC PASS',
                  fullName: 'Acc Passenger',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'fareBookingInd',
                  key: 'FARE BOOK IND',
                  fullName: 'Fare Booking Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'endOfRecordInd',
                  key: 'EOD',
                  fullName: 'End Of Record',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'noOfSegments',
                  key: 'NO OF SEG',
                  fullName: 'No Of Segments',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'cat20SegMinNumber',
                  key: 'S. MIN NO PASS',
                  fullName: 'Segment Min No of Passenger',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'cat20SegMaxNumber',
                  key: 'S. MAX NO PASS',
                  fullName: 'Segment Max No of Passenger',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'cat20SegPassengerTypeCode',
                  key: 'S. PTC',
                  fullName: 'Segment Passenger Type Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'cat20SegMaxAge',
                  key: 'S. MAX AGE',
                  fullName: 'Segment Maximum age',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'cat20SegMinAge',
                  key: 'S. MIN AGE',
                  fullName: 'Segment Minimum Age',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'cat20SegFareClassCode',
                  key: 'S. FCC',
                  fullName: 'Segment Fare Class Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'geographic995Id',
                  key: 'GEO 995',
                  fullName: 'Geographic 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'locationType',
                  key: 'LOCTYP 995',
                  fullName: 'Geo Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'LOC1 995',
                  fullName: 'Geo Loc1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'LOC2 995',
                  fullName: 'Geo Loc2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'TSI 995',
                  fullName: 'Geo TSI Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '21 - Agent Discount',
            sectionKey: 'record3s',
            categoryNumber: '21',
            fields: [
               {
                  field: 'noDiscountInd',
                  key: 'NO DISC IND',
                  fullName: 'No Discount Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'passengerTypeCode',
                  key: 'PTC',
                  fullName: 'Passenger Type Code',
                  characterLimit: 3,
                  placeHolder: 'ABC',
                  inputType: 'text',
               },
               {
                  field: 'idRequirementInd',
                  key: 'ID REQ IND',
                  fullName: 'Id Required Indicator',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'minimumAge',
                  key: 'MIN AGE',
                  fullName: 'Minimum Age',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'maximumAge',
                  key: 'MAX AGE',
                  fullName: 'Maximum Age',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'firstTravelOccurrence',
                  key: 'FIRST TVL',
                  fullName: 'First travel occur',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'lastTravelOccurrence',
                  key: 'LAST TVL',
                  fullName: 'Last travel occur',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'fareInd',
                  key: 'FARE IND',
                  fullName: 'Fare Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'percentApplication',
                  key: 'PERCENT APP',
                  fullName: 'Percent Application',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'owRtInd',
                  key: 'OWRT',
                  fullName: 'OW/RT Indicator',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'baseFareType',
                  key: 'FARE TYPE',
                  fullName: 'Base Fare Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'baseFareApplication',
                  key: 'FARE APP',
                  fullName: 'Base Fare App',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'bookingApplicationInd',
                  key: 'BOOK APP IND',
                  fullName: 'Booking App Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'bookingCode',
                  key: 'BOOK CODE',
                  fullName: 'Booking Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'betweenCityCode',
                  key: 'BET CITY CODE',
                  fullName: 'Between City Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'andCityCode',
                  key: 'AND CITY CODE',
                  fullName: 'AND City Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'specifiedFare1',
                  key: 'SPEC FARE 1',
                  fullName: 'Specified Fare 1',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'currency1Code',
                  key: 'CURR 1',
                  fullName: 'Currency 1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'decimal1Number',
                  key: 'DEC 1',
                  fullName: 'Decimal 1',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'specifiedFare2',
                  key: 'SPEC FARE 2',
                  fullName: 'Specified Fare 2',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'currency2Code',
                  key: 'CURR 2',
                  fullName: 'Currency 2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'decimal2Number',
                  key: 'DEC 2',
                  fullName: 'Decimal 2',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'resultingOwRtInd',
                  key: 'RES OWRT',
                  fullName: 'Resulting OwRt',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'resultingFareClass',
                  key: 'RES FCC',
                  fullName: 'Resulting Fare Class',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'resultingBookingCode',
                  key: 'RES BC',
                  fullName: 'Resulting Booking Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'ticketingCode',
                  key: 'TKT CODE',
                  fullName: 'Ticketing Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 10,
                  placeHolder: 'A1B2C3D4E5',
                  inputType: 'text',
               },
               {
                  field: 'ticketingCodeModifier',
                  key: 'TKT CODE MOD',
                  fullName: 'Ticketing Code Modifier',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'ticketDesignator',
                  key: 'TKT DES',
                  fullName: 'Ticket Designator',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 10,
                  placeHolder: 'A1B2C3D4E5',
                  inputType: 'text',
               },
               {
                  field: 'ticketDesignatorModifier',
                  key: 'TKT DES MOD',
                  fullName: 'Ticket designator modifier',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'allSectorsInd',
                  key: 'ALL SEC IND',
                  fullName: 'All Sectors Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'outboundJourneyInd',
                  key: 'OUT IND',
                  fullName: 'Outboud Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'atLeastOneSectorInd',
                  key: 'ONE SEC IND',
                  fullName: 'Atleast One Sector Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'sameCompartmentInd',
                  key: 'SAME COMP',
                  fullName: 'Same Compartment',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'sameRuleInd',
                  key: 'SAME RULE',
                  fullName: 'Same Rule Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'accompanyingPassengerInd',
                  key: 'ACC PASS',
                  fullName: 'Acc Passenger',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'fareBookingInd',
                  key: 'FARE BOOK IND',
                  fullName: 'Fare Booking Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'endOfRecordInd',
                  key: 'EOD',
                  fullName: 'End Of Record',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'noOfSegments',
                  key: 'NO OF SEG',
                  fullName: 'No Of Segments',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'cat21SegMinNumber',
                  key: 'S. MIN NO PASS',
                  fullName: 'Segment Min No of Passenger',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'cat21SegMaxNumber',
                  key: 'S. MAX NO PASS',
                  fullName: 'Segment Max No of Passenger',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'cat21SegPassengerTypeCode',
                  key: 'S. PTC',
                  fullName: 'Segment Passenger Type Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'cat21SegMaxAge',
                  key: 'S. MAX AGE',
                  fullName: 'Segment Maximum age',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'cat21SegMinAge',
                  key: 'S. MIN AGE',
                  fullName: 'Segment Minimum Age',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'cat21SegFareClassCode',
                  key: 'S. FCC',
                  fullName: 'Segment Fare Class Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'geographic995Id',
                  key: 'GEO 995',
                  fullName: 'Geographic 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'locationType',
                  key: 'LOCTYP 995',
                  fullName: 'Geo Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'LOC1 995',
                  fullName: 'Geo Loc1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'LOC2 995',
                  fullName: 'Geo Loc2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'TSI 995',
                  fullName: 'Geo TSI Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '22 - Other Discount',
            sectionKey: 'record3s',
            categoryNumber: '22',
            fields: [
               {
                  field: 'noDiscountInd',
                  key: 'NO DISC IND',
                  fullName: 'No Discount Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'passengerTypeCode',
                  key: 'PTC',
                  fullName: 'Passenger Type Code',
                  characterLimit: 3,
                  placeHolder: 'ABC',
                  inputType: 'text',
               },
               {
                  field: 'idRequirementInd',
                  key: 'ID REQ IND',
                  fullName: 'Id Required Indicator',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'minimumAge',
                  key: 'MIN AGE',
                  fullName: 'Minimum Age',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'maximumAge',
                  key: 'MAX AGE',
                  fullName: 'Maximum Age',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'firstTravelOccurrence',
                  key: 'FIRST TVL',
                  fullName: 'First travel occur',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'lastTravelOccurrence',
                  key: 'LAST TVL',
                  fullName: 'Last travel occur',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'fareInd',
                  key: 'FARE IND',
                  fullName: 'Fare Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'percentApplication',
                  key: 'PERCENT APP',
                  fullName: 'Percent Application',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'owRtInd',
                  key: 'OWRT',
                  fullName: 'OW/RT Indicator',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'baseFareType',
                  key: 'FARE TYPE',
                  fullName: 'Base Fare Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'baseFareApplication',
                  key: 'FARE APP',
                  fullName: 'Base Fare App',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'bookingApplicationInd',
                  key: 'BOOK APP IND',
                  fullName: 'Booking App Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'bookingCode',
                  key: 'BOOK CODE',
                  fullName: 'Booking Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'betweenCityCode',
                  key: 'BET CITY CODE',
                  fullName: 'Between City Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'andCityCode',
                  key: 'AND CITY CODE',
                  fullName: 'AND City Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'specifiedFare1',
                  key: 'SPEC FARE 1',
                  fullName: 'Specified Fare 1',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'currency1Code',
                  key: 'CURR 1',
                  fullName: 'Currency 1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'decimal1Number',
                  key: 'DEC 1',
                  fullName: 'Decimal 1',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'specifiedFare2',
                  key: 'SPEC FARE 2',
                  fullName: 'Specified Fare 2',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'currency2Code',
                  key: 'CURR 2',
                  fullName: 'Currency 2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'decimal2Number',
                  key: 'DEC 2',
                  fullName: 'Decimal 2',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'resultingOwRtInd',
                  key: 'RES OWRT',
                  fullName: 'Resulting OwRt',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'resultingFareClass',
                  key: 'RES FCC',
                  fullName: 'Resulting Fare Class',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'resultingBookingCode',
                  key: 'RES BC',
                  fullName: 'Resulting Booking Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'ticketingCode',
                  key: 'TKT CODE',
                  fullName: 'Ticketing Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 10,
                  placeHolder: 'A1B2C3D4E5',
                  inputType: 'text',
               },
               {
                  field: 'ticketingCodeModifier',
                  key: 'TKT CODE MOD',
                  fullName: 'Ticketing Code Modifier',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'ticketDesignator',
                  key: 'TKT DES',
                  fullName: 'Ticket Designator',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 10,
                  placeHolder: 'A1B2C3D4E5',
                  inputType: 'text',
               },
               {
                  field: 'ticketDesignatorModifier',
                  key: 'TKT DES MOD',
                  fullName: 'Ticket designator modifier',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'allSectorsInd',
                  key: 'ALL SEC IND',
                  fullName: 'All Sectors Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'outboundJourneyInd',
                  key: 'OUT IND',
                  fullName: 'Outboud Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'atLeastOneSectorInd',
                  key: 'ONE SEC IND',
                  fullName: 'Atleast One Sector Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'sameCompartmentInd',
                  key: 'SAME COMP',
                  fullName: 'Same Compartment',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'sameRuleInd',
                  key: 'SAME RULE',
                  fullName: 'Same Rule Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'accompanyingPassengerInd',
                  key: 'ACC PASS',
                  fullName: 'Acc Passenger',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'fareBookingInd',
                  key: 'FARE BOOK IND',
                  fullName: 'Fare Booking Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'endOfRecordInd',
                  key: 'EOD',
                  fullName: 'End Of Record',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'noOfSegments',
                  key: 'NO OF SEG',
                  fullName: 'No Of Segments',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'cat22SegMinNumber',
                  key: 'S. MIN NO PASS',
                  fullName: 'Segment Min No of Passenger',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'cat22SegMaxNumber',
                  key: 'S. MAX NO PASS',
                  fullName: 'Segment Max No of Passenger',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'cat22SegPassengerTypeCode',
                  key: 'S. PTC',
                  fullName: 'Segment Passenger Type Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'cat22SegMaxAge',
                  key: 'S. MAX AGE',
                  fullName: 'Segment Maximum age',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'cat22SegMinAge',
                  key: 'S. MIN AGE',
                  fullName: 'Segment Minimum Age',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'cat22SegFareClassCode',
                  key: 'S. FCC',
                  fullName: 'Segment Fare Class Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'geographic995Id',
                  key: 'GEO 995',
                  fullName: 'Geographic 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'locationType',
                  key: 'LOCTYP 995',
                  fullName: 'Geo Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'LOC1 995',
                  fullName: 'Geo Loc1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'LOC2 995',
                  fullName: 'Geo Loc2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'TSI 995',
                  fullName: 'Geo TSI Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '23 - Miscellaneous Fare Tags',
            sectionKey: 'record3s',
            categoryNumber: '23',
            fields: [
               {
                  field: 'constructionFareCode',
                  key: 'CON IND',
                  fullName: 'Construction Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'prorateCode',
                  key: 'PRO IND',
                  fullName: 'Prorate Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'differentialCode',
                  key: 'DIFF IND',
                  fullName: 'Differential Code Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'proportionalInd',
                  key: 'EXT IND',
                  fullName: 'Extension Fare Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '26 - Groups',
            sectionKey: 'record3s',
            categoryNumber: '26',
            fields: [
               {
                  field: 'groupType',
                  key: 'GROUP TYPE',
                  fullName: 'Group Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'minGroupSize',
                  key: 'MIN GRP',
                  fullName: 'Minimum Group Size',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 4,
                  placeHolder: '1234',
                  inputType: 'text',
               },
               {
                  field: 'maxGroupSize',
                  key: 'MAX GRP',
                  fullName: 'Maximum Group Size',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 4,
                  placeHolder: '1234',
                  inputType: 'text',
               },
               {
                  field: 'fareClassType',
                  key: 'FARE CLASS',
                  fullName: 'Fare Class Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'flightNumber',
                  key: 'FLIGHT NO',
                  fullName: 'Flight Number',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'validityIndicator',
                  key: 'VAL IND',
                  fullName: 'Validity Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'applicationType',
                  key: 'APP TYPE',
                  fullName: 'Application Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'numberOfChildren',
                  key: 'NO OF CHILD',
                  fullName: 'Number of Children',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'childFarePercentage',
                  key: 'CH PERCENT',
                  fullName: 'Child Fare Percentage',
                  validationName: 'AMOUNT',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: 'ABCDEFG',
                  inputType: 'text',
               },
               {
                  field: 'fareClassCode',
                  key: 'FCC',
                  fullName: 'Fare Class Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'childFareType',
                  key: 'CH FARE TYPE',
                  fullName: 'Child Fare Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'reqType',
                  key: 'NM REQ TYPE',
                  fullName: 'Name Req Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'timeOfDay',
                  key: 'TOD',
                  fullName: 'Time Of day',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 4,
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'namePeriod',
                  key: 'NM PERIOD',
                  fullName: 'Name Period',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'nameUnit',
                  key: 'NM UNIT',
                  fullName: 'Name Unit',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'nameApplCode',
                  key: 'NM APP CODE',
                  fullName: 'Name Appl Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'itinerary',
                  key: 'ITI',
                  fullName: 'Itinerary',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'pnr',
                  key: 'PNR',
                  fullName: 'PNR',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'fareCode',
                  key: 'FARE CODE',
                  fullName: 'Special Fare Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'additionalPassengers',
                  key: 'ADD PASS NO',
                  fullName: 'Additional Passenger No',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'totalGroupPercent',
                  key: 'GR PERCENT',
                  fullName: 'Group Percentage',
                  validationName: 'AMOUNT',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: 'ABCDEFG',
                  inputType: 'text',
               },
               {
                  field: 'departTimeOfDay',
                  key: 'DE TOD',
                  fullName: 'Depart Time of day',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 4,
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'elapsedTimePeriod',
                  key: 'EL TIME P',
                  fullName: 'Elapsed Time Period',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'precedingPeriod',
                  key: 'EL TIME U',
                  fullName: 'Elapsed Time Unit',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'ticketingTimeOfDay',
                  key: 'TKT TOD',
                  fullName: 'Ticketing time of day',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 4,
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'additionalPeriod',
                  key: 'ADD TIME P',
                  fullName: 'Additional Time Period',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'unit1',
                  key: 'ADD TIME U',
                  fullName: 'Additional Time Unit',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'imm1',
                  key: 'TKT IMM',
                  fullName: 'Ticketed Immediately',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'maxSubstitutePassengers',
                  key: 'SUB PASS NO',
                  fullName: 'No of Substituted Passenger',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'maxPercent',
                  key: 'MAX PERCENT',
                  fullName: 'Maximum Percentage',
                  validationName: 'AMOUNT',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: 'ABCDEFG',
                  inputType: 'text',
               },
               {
                  field: 'lastTimeOfDay',
                  key: 'LAST TOD',
                  fullName: 'Last Time Of Day',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 4,
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'elapsedPeriod',
                  key: 'SUB EL TIME P',
                  fullName: 'Substitute Elapsed Period',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'unit2',
                  key: 'SUB EL TIME U',
                  fullName: 'Substitute Elapsed Unit',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'lastTicketingTimeOfDay',
                  key: 'SUB TKT TOD',
                  fullName: 'Sub Ticketing Time of Day',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 4,
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'period',
                  key: 'SUB EL P',
                  fullName: 'Sub Elapsed Period',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'unit3',
                  key: 'SUB EL U',
                  fullName: 'Sub Unit',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'imm2',
                  key: 'SUB TKT IMM',
                  fullName: 'Sub Ticketed Immediately',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'minNumberOfSectors',
                  key: 'MIN NO SEC',
                  fullName: 'Min no of Sectors',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'outbound',
                  key: 'OUT',
                  fullName: 'Outbound Transfers',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'inbound',
                  key: 'IN',
                  fullName: 'Inbound Transfers',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'inboundOrOutbound',
                  key: 'OUT/IN',
                  fullName: 'Either In or Out',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'timeFrameCode',
                  key: 'TIME APP',
                  fullName: 'Time Applicable',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'waiverCode',
                  key: 'WAV CODE',
                  fullName: 'Waiver Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'permitCode',
                  key: 'PERM CODE',
                  fullName: 'Permitted Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'sameCode',
                  key: 'SAME CXR CODE',
                  fullName: 'Same Carrier code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'inboundOrOutboundOrChanged',
                  key: 'OUT/IN/CHANGE',
                  fullName: 'Inbound/Outbound or Changed',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'additionalAmount1',
                  key: 'ADD AMT 1',
                  fullName: 'Additional Amount 1',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'currencyCode1',
                  key: 'CURR 1',
                  fullName: 'Currency 1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'decimalPlace1',
                  key: 'DECIMAL 1',
                  fullName: 'Decimal 1',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'additionalAmount2',
                  key: 'ADD AMT 2',
                  fullName: 'Additional Amount 2',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'currencyCode2',
                  key: 'CURR 2',
                  fullName: 'Currency 2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'decimalPlace2',
                  key: 'DECIMAL 2',
                  fullName: 'Decimal 2',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'minNumberOfPassengers',
                  key: 'MIN NUM PASS',
                  fullName: 'Minimum Number of Passenger',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 4,
                  placeHolder: '1234',
                  inputType: 'text',
               },
               {
                  field: 'returnCode',
                  key: 'RETURN',
                  fullName: 'Return Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'minNumberOfTourParticipants',
                  key: 'MIN TOUR PASS',
                  fullName: 'Min no of Tour Participants',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 4,
                  placeHolder: '1234',
                  inputType: 'text',
               },
               {
                  field: 'maxNumberOfTourParticipants',
                  key: 'MAX TOUR PASS',
                  fullName: 'Max no of Tour Participants',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 4,
                  placeHolder: '1234',
                  inputType: 'text',
               },
               {
                  field: 'numberOfTourConductors',
                  key: 'NO TOUR COND',
                  fullName: 'Number of Tour Conductors',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'numberOfPayingPassengers',
                  key: 'NO PAY PASS',
                  fullName: 'Number of Paying Passenger',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 4,
                  placeHolder: '1234',
                  inputType: 'text',
               },
               {
                  field: 'maxNumberOfTourConductors',
                  key: 'MAX TOUR COND',
                  fullName: 'Max no if Tour Conductors',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'minAgeOfTourConductor',
                  key: 'MIN AGE',
                  fullName: 'Minimum Age',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'tvlCode',
                  key: 'TVL CODE',
                  fullName: 'Travel Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'diff',
                  key: 'DIFF GRP',
                  fullName: 'Different Groups',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'writ',
                  key: 'WRT APP',
                  fullName: 'Written Application',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'andTable995Id',
                  key: 'AND995ID',
                  fullName: 'AND GEO 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'betweenTable995Id',
                  key: 'BET995ID',
                  fullName: 'Between GEO 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'geographic995Id',
                  key: 'GEO995ID',
                  fullName: 'GEO 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'groupAndTable995Id',
                  key: 'GR AND995ID',
                  fullName: 'Group AND GEO 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'groupBetweenTable995Id',
                  key: 'GR BET995ID',
                  fullName: 'Group Between GEO 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'groupTourAndTable995Id',
                  key: 'GR TO AND995ID',
                  fullName: 'Group Tour AND GEO 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'groupTourBetweenTable995Id',
                  key: 'GR TO BET995ID',
                  fullName: 'Group Tour Between GEO 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'individualAndTable995Id',
                  key: 'IND AND995ID',
                  fullName: 'Individual AND GEO 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'individualBetweenTable995Id',
                  key: 'IND BET995ID',
                  fullName: 'Individual Between GEO 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'locationType',
                  key: 'LOCTYP',
                  fullName: 'Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'LOC1',
                  fullName: 'Location 1',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'LOC2',
                  fullName: 'Location 2',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'TSI',
                  fullName: 'Travel Segment Indicator',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '27 - Tours',
            sectionKey: 'record3s',
            categoryNumber: '27',
            fields: [
               {
                  field: 'tourTypeCode',
                  key: 'TOUR TYPE',
                  fullName: 'Tour Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'tourNumber',
                  key: 'TOUR NO',
                  fullName: 'Tour Number',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'carrierCode',
                  key: 'CXR CODE',
                  fullName: 'Carrier Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'numNights',
                  key: 'NO OF NIGHTS',
                  fullName: 'Number of Nights',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'minAppl1Code',
                  key: 'MIN AMT 1 APP',
                  fullName: 'Min Amount 1 Application',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'minAmount1',
                  key: 'MIN AMT 1',
                  fullName: 'Min Amount 1',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'additionalAppl1Code',
                  key: 'ADD 1 APP',
                  fullName: 'Additional Night 1 App',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'additionalAmount1',
                  key: 'ADD 1 AMT',
                  fullName: 'Additional Amount 1',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'currency1Code',
                  key: 'CURR 1',
                  fullName: 'Currency 1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'decimals1Number',
                  key: 'DECIMAL 1',
                  fullName: 'Decimal 1',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'minAppl2Code',
                  key: 'MIN AMT 2 APP',
                  fullName: 'Min Amount 2 Application',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'minAmount2',
                  key: 'MIN AMT 2',
                  fullName: 'Min Amount 2',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'additionalAppl2Code',
                  key: 'ADD 2 APP',
                  fullName: 'Additional Night 2 App',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'additionalAmount2',
                  key: 'ADD 2 AMT',
                  fullName: 'Additional Amount 2',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'currency2Code',
                  key: 'CURR 2',
                  fullName: 'Currency 2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'decimals2Number',
                  key: 'DECIMAL 2',
                  fullName: 'Decimal 2',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'minimumPercent',
                  key: 'MIN PERCENT',
                  fullName: 'Minimum Percent',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'priceMinimum1Amount',
                  key: 'MIN TOUR AMT 1',
                  fullName: 'Minimum Tour Price 1',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'priceCurrency1Code',
                  key: 'CURR 1',
                  fullName: 'Currency 1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'priceDecimals1Number',
                  key: 'DECIMAL 1',
                  fullName: 'Decimal 1',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'priceMinimum2Amount',
                  key: 'MIN TOUR AMT 2',
                  fullName: 'Minimum Tour Price 2',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'priceCurrency2Code',
                  key: 'CURR 2',
                  fullName: 'Currency 2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'priceDecimals2Number',
                  key: 'DECIMAL 2',
                  fullName: 'Decimal 2',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'priceApplCode',
                  key: 'TOUR APP CODE',
                  fullName: 'Tour Price App Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'passengerTypeCode',
                  key: 'PTC',
                  fullName: 'Passenger Type Code',
                  characterLimit: 3,
                  placeHolder: 'ABC',
                  inputType: 'text',
               },
               {
                  field: 'minimumAge',
                  key: 'MIN AGE',
                  fullName: 'Minimum Age',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'maximumAge',
                  key: 'MAX AGE',
                  fullName: 'Maximum Age',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'nonRefundableInd',
                  key: 'NON REF',
                  fullName: 'Non Refundable Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'waiverApplicationCode',
                  key: 'WAV APP',
                  fullName: 'Waiver App Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'passengerDeathInd',
                  key: 'DEATH IND',
                  fullName: 'Death Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'passengerIllInd',
                  key: 'ILL IND',
                  fullName: 'Illness Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'scheduleChangeInd',
                  key: 'SCH CH IND',
                  fullName: 'Schedule Change Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'ticketUpgradeInd',
                  key: 'TKT UG IND',
                  fullName: 'Ticket Upgrade Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'documentDenialInd',
                  key: 'DOC DEN IND',
                  fullName: 'Document denial Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'juryDutyInd',
                  key: 'JURY IND',
                  fullName: 'Jury Duty Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'militaryOrdersInd',
                  key: 'MIL IND',
                  fullName: 'Military Orders Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'fareIncreaseInd',
                  key: 'FARE INC IND',
                  fullName: 'Fare Increase Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'paymentReceivedInd',
                  key: 'PAY REC IND',
                  fullName: 'Payment Received Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'numberOfSegments',
                  key: 'NO OF SEG',
                  fullName: 'No Of Segments',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'cat27SegMinimumGroundAmount',
                  key: 'MIN GR AMT',
                  fullName: 'Minimum Ground Amount',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'cat27SegCurrencyCode',
                  key: 'GR CURR',
                  fullName: 'Ground Currency Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'cat27SegDecimalPlaces',
                  key: 'GR DECIMAL',
                  fullName: 'Ground Decimal',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'cat27SegDayTotalIndicator',
                  key: 'GR APP',
                  fullName: 'Minimum Ground Application',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'cat27SegTransferNumber',
                  key: 'MIN TRANSFER',
                  fullName: 'Minimum Transfer Number',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'cat27SegMinimumCarRentalDays',
                  key: 'CAR REN DAY',
                  fullName: 'Car Rental Days',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'cat27SegMinimumDaysAtResort',
                  key: 'RESORT DAY',
                  fullName: 'Days at Resort',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'cat27SegMinimumDaysOnShip',
                  key: 'SHIP DAY',
                  fullName: 'Days on Ship',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'cat27SegOtherMinimumDays',
                  key: 'OTH GR DAY',
                  fullName: 'Other Ground Days',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'cat27SegMaximumConsecutiveFreeDays',
                  key: 'FREE DAYS',
                  fullName: 'Consecutive Free Days',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '28 - Visit Another Country',
            sectionKey: 'record3s',
            categoryNumber: '28',
            fields: [
               {
                  field: 'passengerTypeCode',
                  key: 'PTC',
                  fullName: 'Passenger Type Code',
                  characterLimit: 3,
                  placeHolder: 'ABC',
                  inputType: 'text',
               },
               {
                  field: 'identificationTag',
                  key: 'IND TAG',
                  fullName: 'Identification Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'minimumAgeOfPassenger',
                  key: 'MIN AGE',
                  fullName: 'Minimum Age',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'maximumAgeOfPassenger',
                  key: 'MAX AGE',
                  fullName: 'Maximum Age',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'residentCode',
                  key: 'RES CODE',
                  fullName: 'Resident Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'travelIndicator',
                  key: 'TVL IND',
                  fullName: 'Travel Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'numberOfMiles',
                  key: 'NO OF MILES',
                  fullName: 'Number of Miles',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'vacTypeTicketIndicator',
                  key: 'TKT TYPE IND',
                  fullName: 'Ticket Type Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'localeGeographic995Id',
                  key: 'LOCALE GEO',
                  fullName: 'Locale GEO 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'locationType',
                  key: 'LOCALE LOCTYP',
                  fullName: 'Locale Geo Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'LOCALE LOC1',
                  fullName: 'Locale Geo Loc1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'LOCALE LOC2',
                  fullName: 'Locale Geo Loc2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'LOCALE TSI',
                  fullName: 'LocaleGeo TSI Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'nonResidenceGeographic995Id',
                  key: 'NON R GEO',
                  fullName: 'Non Residence GEO 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'locationType',
                  key: 'NON R LOCTYP',
                  fullName: 'Non Res Geo Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'NON R LOC1',
                  fullName: 'Non Res Geo Loc1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'NON R LOC2',
                  fullName: 'Non Res Geo Loc2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'NON R TSI',
                  fullName: 'Non res Geo TSI Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '29 - Deposits',
            sectionKey: 'record3s',
            categoryNumber: '29',
            fields: [
               {
                  field: 'depositRequiredCode',
                  key: 'DEP REQ CODE',
                  fullName: 'Deposit Req Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'firstMinimumDepositAmount',
                  key: 'FIRST MIN AMT',
                  fullName: 'First Min Deposit Amt',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'firstDepositCurrencyCode',
                  key: 'FIRST MIN CURR',
                  fullName: 'First Min Deposit Curr',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'decimalPlacesForFirstCurrency',
                  key: 'FIRST MIN DEC',
                  fullName: 'First Min Deposit Decimal',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'secondMinimumDepositAmount',
                  key: 'SEC MIN AMT',
                  fullName: 'Sec Min Deposit Amt',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'secondDepositCurrencyCode',
                  key: 'SEC MIN CURR',
                  fullName: 'Sec Min Deposit Curr',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'decimalPlacesForSecondCurrency',
                  key: 'SEC MIN DEC',
                  fullName: 'Sec Min Deposit Decimal',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'farePercentToDeposit',
                  key: 'FARE PER DEP',
                  fullName: 'Fare Percent To Deposit',
                  validationName: 'AMOUNT',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: 'ABCDEFG',
                  inputType: 'text',
               },
               {
                  field: 'depositApplCode',
                  key: 'DEP APP CODE',
                  fullName: 'Deposit App Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'depositDays',
                  key: 'DEP CODE',
                  fullName: 'Deposit Code',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'lastDate',
                  key: 'LAST DATE',
                  fullName: 'Last Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 6,
                  placeHolder: 'A1B2C3',
                  inputType: 'text',
               },
               {
                  field: 'seatDepositIndicator',
                  key: 'SEAT DEP IND',
                  fullName: 'Seat Deposit Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'nonRefundableDepositIndicator',
                  key: 'NON REF IND',
                  fullName: 'Non Refundable Deposit Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'firstRefundableAmount',
                  key: 'FIRST REF AMT',
                  fullName: 'First Refund Amount',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'firstRefundCurrencyCode',
                  key: 'FIRST REF CURR',
                  fullName: 'First Refund Curr',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'decimalPlacesForFirstRefundCurrency',
                  key: 'FIRST REF DEC',
                  fullName: 'First Refund Decimal',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'secondRefundableAmount',
                  key: 'SEC REF AMT',
                  fullName: 'Sec Refund Amount',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'secondRefundCurrencyCode',
                  key: 'SEC REF CURR',
                  fullName: 'Sec Refund Curr',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'decimalPlacesForSecondRefundCurrency',
                  key: 'SEC REF DEC',
                  fullName: 'Sec Refund Decimal',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'refundPercent',
                  key: 'REF PERCENT',
                  fullName: 'Refund Percent',
                  validationName: 'AMOUNT',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: 'ABCDEFG',
                  inputType: 'text',
               },
               {
                  field: 'refundApplCode',
                  key: 'REF APP CODE',
                  fullName: 'Refund Application Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'refundDays',
                  key: 'REF DAYS',
                  fullName: 'Refund Days',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'waiversApplCode',
                  key: 'WAV APP CODE',
                  fullName: 'Waiver App Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'deathCode',
                  key: 'DEATH CODE',
                  fullName: 'Death Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'illnessCode',
                  key: 'ILL CODE',
                  fullName: 'Illness Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'scheduleChange',
                  key: 'SCH CHANGE',
                  fullName: 'Schedule Change',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'ticketUpgrade',
                  key: 'TKT UG',
                  fullName: 'Ticket Upgrade',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'denialOfDocuments',
                  key: 'DENIAL DOCS',
                  fullName: 'Denial Of Docs',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'juryDuty',
                  key: 'JURY DUTY',
                  fullName: 'Jury Duty',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'militaryOrders',
                  key: 'MIL ORDER',
                  fullName: 'Military Orders',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'airfareIncrease',
                  key: 'AIRFARE INC',
                  fullName: 'Airfare Increase',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'fullyPaidForSeats',
                  key: 'FULL SEATS',
                  fullName: 'Full Paid Seats',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'depositGeographic995Id',
                  key: 'DEP GEO 995',
                  fullName: 'Deposit Geo 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'locationType',
                  key: 'DEP LOCTYP',
                  fullName: 'Dep Geo Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'DEP LOC1',
                  fullName: 'Dep Geo Loc1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'DEP LOC2',
                  fullName: 'Dep Geo Loc2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'DEP TSI',
                  fullName: 'Dep Geo TSI Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'refundGeographic995Id',
                  key: 'REF GEO 995',
                  fullName: 'Refund Geo 995 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'locationType',
                  key: 'REF LOCTYP',
                  fullName: 'Ref Geo Location Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'location1Code',
                  key: 'REF LOC1',
                  fullName: 'Ref Geo Loc1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'location2Code',
                  key: 'REF LOC2',
                  fullName: 'Ref Geo Loc2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'travelSegmentIndicator',
                  key: 'REF TSI',
                  fullName: 'Ref Geo TSI Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '31 - Voluntary Changes',
            sectionKey: 'record3s',
            categoryNumber: '31',
            fields: [
               {
                  field: 'passengerTypeCode',
                  key: 'PTC',
                  fullName: 'Passenger Type Code',
                  characterLimit: 3,
                  placeHolder: 'ABC',
                  inputType: 'text',
               },
               {
                  field: 'ticketValidityInd',
                  key: 'TKT VAL IND',
                  fullName: 'Ticket Validity Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'journeyCode',
                  key: 'JRNY CODE',
                  fullName: 'Journey Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'pricingUnit',
                  key: 'PRICE UNIT',
                  fullName: 'Pricing Unit',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'fareComponentCode',
                  key: 'FARE CO CODE',
                  fullName: 'Fare Component code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'fromPointCode',
                  key: 'FROM CODE',
                  fullName: 'From Point Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'toPointCode',
                  key: 'TO CODE',
                  fullName: 'To Point code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'lastPeriod',
                  key: 'LAST P',
                  fullName: 'Last Period',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'lastUnit',
                  key: 'LAST U',
                  fullName: 'Last Unit',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'changeInd',
                  key: 'CHANGE IND',
                  fullName: 'Change Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'firstOccurrence',
                  key: 'FIRST OCC',
                  fullName: 'First Occurrence',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'lastOccurrence',
                  key: 'LAST OCC',
                  fullName: 'Last Occurrence',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'penalty1Amount',
                  key: 'PEN 1 AMT',
                  fullName: 'Penalty 1 Amount',
                  validationName: 'AMOUNT',
                  dataType: 'number',
                  placeHolder: '100',
                  inputType: 'text',
               },
               {
                  field: 'currency1Code',
                  key: 'CURR 1',
                  fullName: 'Currency 1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'decimals1Number',
                  key: 'DEC 1 NO',
                  fullName: 'Decimal 1',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'penaltyPercent',
                  key: 'PEN PERCENT',
                  fullName: 'Penalty Percent',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'penalty2Amount',
                  key: 'PEN 2 AMT',
                  fullName: 'Penalty 2 Amount',
                  validationName: 'AMOUNT',
                  dataType: 'number',
                  placeHolder: '100',
                  inputType: 'text',
               },
               {
                  field: 'currency2Code',
                  key: 'CURR 2',
                  fullName: 'Currency 2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'decimals2Number',
                  key: 'DEC 2 NO',
                  fullName: 'Decimal 2',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'highLowCode',
                  key: 'H/L CODE',
                  fullName: 'High Low Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'minimumAmount',
                  key: 'MIN AMT',
                  fullName: 'Minimum Amount',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'currencyCode',
                  key: 'CURR CODE',
                  fullName: 'Currency code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'decimalsNumber',
                  key: 'DEC',
                  fullName: 'Decimal',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'assessmentCode',
                  key: 'ASSESS CODE',
                  fullName: 'Assessment code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'feeApplicationCode',
                  key: 'FEE APP CODE',
                  fullName: 'Fee Application code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'ticketTypeCode',
                  key: 'TKT TYPE',
                  fullName: 'Ticket Type code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'discountTypeCode',
                  key: 'DIS TYPE',
                  fullName: 'Discount Type Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 4,
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'residualPenaltyCode',
                  key: 'RES TYPE',
                  fullName: 'Residual Penalty Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'refundTypeCode',
                  key: 'REF TYPE',
                  fullName: 'Refund Type Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'endorsementInd',
                  key: 'ENDO TYPE',
                  fullName: 'Endorsement Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'reissue988Id',
                  key: 'REISSUE 988',
                  fullName: 'Reissue 988 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'waiver987Id',
                  key: 'WAIVER 987',
                  fullName: 'Waiver 987 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '33 - Voluntary Refunds',
            sectionKey: 'record3s',
            categoryNumber: '33',
            fields: [
               {
                  field: 'passengerTypeCode',
                  key: 'PTC',
                  fullName: 'Passenger Type Code',
                  characterLimit: 3,
                  placeHolder: 'ABC',
                  inputType: 'text',
               },
               {
                  field: 'ticketValidityInd',
                  key: 'TKT VAL IND',
                  fullName: 'Ticket Validity Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'ticketPeriod',
                  key: 'TKT P',
                  fullName: 'Ticket Period',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'ticketUnit',
                  key: 'TKT U',
                  fullName: 'Ticket Unit',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'journeyCode',
                  key: 'JRNY CODE',
                  fullName: 'Journey Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'pricingUnit',
                  key: 'PRICE UNIT',
                  fullName: 'Pricing Unit',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'fareComponentCode',
                  key: 'FARE CO CODE',
                  fullName: 'Fare Component code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'fromPointCode',
                  key: 'FROM CODE',
                  fullName: 'From Point Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'lastTimeOfDay',
                  key: 'LAST TOD',
                  fullName: 'Last Time Of Day',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 4,
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'lastPeriod',
                  key: 'LAST P',
                  fullName: 'Last Period',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'lastUnit',
                  key: 'LAST U',
                  fullName: 'Last Unit',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'ticketTimeLimit',
                  key: 'TKT LIMIT',
                  fullName: 'Ticket Time Limit',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'advanceReservationsValidation',
                  key: 'ADV RES',
                  fullName: 'Advance Reservation',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'fullyFlown',
                  key: 'FULL FLOWN',
                  fullName: 'Fully Flown',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'originallyScheduledRefund',
                  key: 'ORG SCH REF',
                  fullName: 'Originally Scheduled Refund',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'originallyScheduledPeriod',
                  key: 'ORG SCH P',
                  fullName: 'Originally Scheduled Period',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'originallyScheduledUnit',
                  key: 'ORG SCH U',
                  fullName: 'Originally Scheduled Unit',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'cancellationIndicator',
                  key: 'CANCEL IND',
                  fullName: 'Cancellation Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'fareBreakPoints',
                  key: 'FARE POINT',
                  fullName: 'Fare Break Points',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'rePriceIndicator',
                  key: 'RE IND',
                  fullName: 'Re Price Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'ruleTariffNumber',
                  key: 'RTN',
                  fullName: 'Rule Tariff Number',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'pvtPubTariffIndicator',
                  key: 'PVT PUB IND',
                  fullName: 'Private Public Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'ruleNumber',
                  key: 'RULE NUM',
                  fullName: 'Rule Number',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 4,
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'fieldIndicator',
                  key: 'FIELD IND',
                  fullName: 'Field Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'fareClassCode',
                  key: 'FCC',
                  fullName: 'Fare Class Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'sameCode',
                  key: 'SAME CODE',
                  fullName: 'Same Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'normalSpecialFareCode',
                  key: 'FARE CODE',
                  fullName: 'Special Fare Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'owRtIndString',
                  key: 'OW/RT',
                  fullName: 'OW/RT Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'fareAmountCode',
                  key: 'FARE AMT',
                  fullName: 'Fare Amount Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'bookingCode',
                  key: 'BOOK CODE',
                  fullName: 'Booking Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'penaltyAmount1',
                  key: 'PEN 1 AMT',
                  fullName: 'Penalty 1 Amount',
                  validationName: 'AMOUNT',
                  dataType: 'number',
                  placeHolder: '100',
                  inputType: 'text',
               },
               {
                  field: 'currencyCode1',
                  key: 'CURR 1',
                  fullName: 'Currency 1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'decimalPlace1',
                  key: 'DEC 1 NO',
                  fullName: 'Decimal 1',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'baseFarePercentage',
                  key: 'BASE PERCENT',
                  fullName: 'Base Fare Percent',
                  validationName: 'AMOUNT',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: 'ABCDEFG',
                  inputType: 'text',
               },
               {
                  field: 'penaltyAmount2',
                  key: 'PEN 2 AMT',
                  fullName: 'Penalty 2 Amount',
                  validationName: 'AMOUNT',
                  dataType: 'number',
                  placeHolder: '100',
                  inputType: 'text',
               },
               {
                  field: 'currencyCode2',
                  key: 'CURR 2',
                  fullName: 'Currency 2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'decimalPlace2',
                  key: 'DEC 2 NO',
                  fullName: 'Decimal 2',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'higherLowerAmountCode',
                  key: 'H/L AMT',
                  fullName: 'High Low Amount Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'minimumAmount',
                  key: 'MIN AMT',
                  fullName: 'Minimum Amount',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'currencyCode3',
                  key: 'CURR 3',
                  fullName: 'Currency 3 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'decimalPlace3',
                  key: 'DEC 3 NO',
                  fullName: 'Decimal 3',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'puFCCode',
                  key: 'PU/FC',
                  fullName: 'PU/FC Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'calculationOption',
                  key: 'CALC OP',
                  fullName: 'Calculation Option',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'discountTag',
                  key: 'DIS TAG',
                  fullName: 'Discount Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 4,
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'formOfRefund',
                  key: 'REFUND',
                  fullName: 'Form Of Refund',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'taxNonRefundCode',
                  key: 'NON REF CODE',
                  fullName: 'Tax Non Refund Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'custFirstPeriod',
                  key: 'CUST P',
                  fullName: 'Customer First Period',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'custFirstUnit',
                  key: 'CUST U',
                  fullName: 'Customer First Unit',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'reservationTicketingCode',
                  key: 'RES TKT CODE',
                  fullName: 'Reservation Ticketing Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'carrier990Id',
                  key: 'CXR 990',
                  fullName: 'Carrier 990 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'fareTypeTable974Id',
                  key: 'FARE TYPE 974',
                  fullName: 'Fare Type Table 974 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'waiver987Id',
                  key: 'WAV 987',
                  fullName: 'Waiver 987 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '35 - Negotiated Fare',
            sectionKey: 'record3s',
            categoryNumber: '35',
            fields: [
               {
                  field: 'security983Id',
                  key: 'SEC 983 ID',
                  fullName: 'Security Table 983 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'passengerTypeCode',
                  key: 'PTC',
                  fullName: 'Passenger Type Code',
                  characterLimit: 3,
                  placeHolder: 'ABC',
                  inputType: 'text',
               },
               {
                  field: 'fareCreator979Id',
                  key: 'FARE 979 ID',
                  fullName: 'Fare Creator 979 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'methodTypeCode',
                  key: 'METHOD TYPE',
                  fullName: 'Method Type Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'netGrossInd',
                  key: 'NET/GROSS',
                  fullName: 'Net Gross Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'commissionPercent',
                  key: 'COMM PERCENT',
                  fullName: 'Commission Percent',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'commission1Amount',
                  key: 'COMM 1 AMT',
                  fullName: 'Commission 1 Amount',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'currency1Code',
                  key: 'CURR 1',
                  fullName: 'Currency 1 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'decimals1Number',
                  key: 'DECIMAL 1',
                  fullName: 'Decimal 1',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'commission2Amount',
                  key: 'COMM 2 AMT',
                  fullName: 'Commission 2 Amount',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'currency2Code',
                  key: 'CURR 2',
                  fullName: 'Currency 2 Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'decimals2Number',
                  key: 'DECIMAL 2',
                  fullName: 'Decimal 2',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 1,
                  placeHolder: '1',
                  inputType: 'text',
               },
               {
                  field: 'upgradeInd',
                  key: 'UG IND',
                  fullName: 'Upgrade Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'baggageNumber',
                  key: 'BAG NO',
                  fullName: 'Baggage Number',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'pieceKilogramInd',
                  key: 'BAG NO APP',
                  fullName: 'Baggage No Application',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'ticketingInd',
                  key: 'TKT IND',
                  fullName: 'Ticketing Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'notPermittedInd',
                  key: 'NOT PERM IND',
                  fullName: 'Not Permitted Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'ticketCarrierCode',
                  key: 'TKT CXR CODE',
                  fullName: 'Ticket Carrier Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'numberOfSegment',
                  key: 'NO OF SEGS',
                  fullName: 'No of Segments',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 2,
                  placeHolder: '12',
                  inputType: 'text',
               },
               {
                  field: 'cat35SegCouponCode',
                  key: 'COUPON CODE',
                  fullName: 'Coupon Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'cat35SegType',
                  key: 'TOUR CODE',
                  fullName: 'Tour Code Type',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'cat35SegTourBoxCode',
                  key: 'TOUR BOX',
                  fullName: 'Tour Box Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 15,
                  placeHolder: 'A1B2C3D4E5',
                  inputType: 'text',
               },
               {
                  field: 'cat35SegTicketDesignator',
                  key: 'TKT DESG',
                  fullName: 'Ticket Designator',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 10,
                  placeHolder: 'A1B2C3D4E5',
                  inputType: 'text',
               },
               {
                  field: 'cat35SegTicketFareData',
                  key: 'TKT FARE DATA',
                  fullName: 'Ticketed Fare Data',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'cat35SegOwrtInd',
                  key: 'OWRT IND',
                  fullName: 'OW/RT Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'cat35SegGlobalInd',
                  key: 'GLOBAL IND',
                  fullName: 'Global Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 2,
                  placeHolder: 'A1',
                  inputType: 'text',
               },
               {
                  field: 'cat35SegRuleTariffNumber',
                  key: 'RTN',
                  fullName: 'Rule Tariff Number',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'cat35SegCarrierCode',
                  key: 'CXR CODE',
                  fullName: 'Carrier Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'cat35SegRuleNumber',
                  key: 'RULE NO',
                  fullName: 'Rule Number',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 4,
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'cat35SegFareClassCode',
                  key: 'FCC',
                  fullName: 'Fare Class Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'cat35SegFareTypeCode',
                  key: 'FTC',
                  fullName: 'Fare Type Code',
                  characterLimit: 3,
                  placeHolder: 'ABC',
                  inputType: 'text',
               },
               {
                  field: 'cat35SegSeasonTypeCode',
                  key: 'STC',
                  fullName: 'Season Type Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'cat35SegDayOfWeekType',
                  key: 'DOW TC',
                  fullName: 'Day Of Week Type Code',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'cat35SegBetweenCityCode',
                  key: 'BET CITY CODE',
                  fullName: 'Between City Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'cat35SegAndCityCode',
                  key: 'AND CITY CODE',
                  fullName: 'AND City Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 5,
                  placeHolder: 'A1B2C',
                  inputType: 'text',
               },
               {
                  field: 'cat35SegFareBox',
                  key: 'FARE BOX TXT',
                  fullName: 'Fare Box Text',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 11,
                  placeHolder: 'A1B2C3D4E5F',
                  inputType: 'text',
               },
               {
                  field: 'cat35SegAmount',
                  key: 'FARE BOX AMT',
                  fullName: 'Fare Box Amount',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 7,
                  placeHolder: '1234567',
                  inputType: 'text',
               },
               {
                  field: 'cat35SegCurrencyCode',
                  key: 'FARE BOX CURR',
                  fullName: 'Fare Box Currency',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 3,
                  placeHolder: 'A1B',
                  inputType: 'text',
               },
               {
                  field: 'cat35SegDecimalPlace',
                  key: 'FARE BOX DEC',
                  fullName: 'Fare Box Decimal',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
            ],
         },
         {
            sectionName: '50 - Rule Application',
            sectionKey: 'record3s',
            categoryNumber: '50',
            fields: [
               {
                  field: 'applicationTitle',
                  key: 'APP TITLE',
                  fullName: 'Application Title',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'firstClassInd',
                  key: 'FIRST CLASS',
                  fullName: 'First Class Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'businessClassInd',
                  key: 'BUS CLASS',
                  fullName: 'Business Class Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'economyClassInd',
                  key: 'ECO CLASS',
                  fullName: 'Economy Class Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'coachClassInd',
                  key: 'COACH CLASS',
                  fullName: 'Coach Class Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'offPeakCoachClassInd',
                  key: 'OFF CO CLASS',
                  fullName: 'Off Peak Coach Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'supersonicInd',
                  key: 'SUPER IND',
                  fullName: 'Supersonic Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'oneWayRuleInd',
                  key: 'OW RULE IND',
                  fullName: 'One Way Rule Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'roundTripRuleInd',
                  key: 'RT RULE IND',
                  fullName: 'Round Trip Rule Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'oneWayInd',
                  key: 'OW IND',
                  fullName: 'One Way Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'roundTripInd',
                  key: 'RT IND',
                  fullName: 'Round Trip Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'circleTripInd',
                  key: 'CT IND',
                  fullName: 'Circle Trip Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'openJawInd',
                  key: 'OJ IND',
                  fullName: 'Open Jaw Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'singleOpenJawInd',
                  key: 'SOJ IND',
                  fullName: 'Single Open Jaw Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'originSojInd',
                  key: 'ORIGIN SOJ IND',
                  fullName: 'Origin SOJ Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'turnAroundSojInd',
                  key: 'TA SOJ IND',
                  fullName: 'Turn Around SOJ Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'doubleOpenJawInd',
                  key: 'DOJ IND',
                  fullName: 'Double Open Jaw Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'roundTheWorldInd',
                  key: 'RTW IND',
                  fullName: 'Round the World Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'jointTransportInd',
                  key: 'JT IND',
                  fullName: 'Joint Transport Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'inclusiveToursCode',
                  key: 'INC TOUR',
                  fullName: 'Inclusive Tour Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'groupsCode',
                  key: 'GROUP CODE',
                  fullName: 'Group Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'purchaseCode',
                  key: 'PUR CODE',
                  fullName: 'Purchase Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'intermediatePointsInd',
                  key: 'INTER POINTS',
                  fullName: 'Intermediate Points Ind',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'domIntCode',
                  key: 'D/I CODE',
                  fullName: 'Dom Int Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'noOfSegments',
                  key: 'SEG NO',
                  fullName: 'No. of Segments',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 3,
                  placeHolder: '123',
                  inputType: 'text',
               },
               {
                  field: 'cat50SegGeoLocalCode',
                  key: 'LOCALE CODE',
                  fullName: 'Geo Locale Code',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'cat50SegLocationCode',
                  key: 'LOC CODE',
                  fullName: 'Location Code',
                  characterLimit: 3,
                  placeHolder: 'ABCDE',
                  inputType: 'text',
               },
               {
                  field: 'cat50SegLocationType',
                  key: 'LOC TYPE',
                  fullName: 'Location Type',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'addlFareText996Id',
                  key: 'ADD FARE TEXT ID',
                  fullName: 'Additional Fare Text 996 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'ADD FARE TEXT',
                  fullName: 'Additional Fare Text 996',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'capacityText996Id',
                  key: 'CAPA TEXT ID',
                  fullName: 'Capacity Text 996 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'CAPA TEXT',
                  fullName: 'Capacity Text 996',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'notApplText996Id',
                  key: 'NO APP ID',
                  fullName: 'Not Application Text 996 ID',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'NO APP TEXT',
                  fullName: 'Not Application Text 996',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'otherText996Id',
                  key: 'OTHER TEXT ID',
                  fullName: 'Other Text 996 ID',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'OTHER TEXT',
                  fullName: 'Other Text 996',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  placeHolder: 'A1B2',
                  inputType: 'text',
               },
               {
                  field: 'dateOverride994Id',
                  key: 'OVRD 994',
                  fullName: 'Override 994 Id',
                  validationName: 'NUMERIC',
                  dataType: 'number',
                  characterLimit: 8,
                  placeHolder: '12345678',
                  inputType: 'text',
               },
               {
                  field: 'travelEffectiveDate',
                  key: 'TVLEFF 994',
                  fullName: 'Override Travel Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'travelDiscontinueDate',
                  key: 'TVLDIS 994',
                  fullName: 'Override Travel Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationEffectiveDate',
                  key: 'RESEFF 994',
                  fullName: 'Override Reser Eff Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'reservationDiscontinueDate',
                  key: 'RESDISC 994',
                  fullName: 'Override Reser Disc Date',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 7,
                  placeHolder: 'A1B2C3D',
                  inputType: 'text',
               },
               {
                  field: 'text996Id',
                  key: 'TEXT 996',
                  fullName: 'Text 996 Id',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 8,
                  placeHolder: 'A1B2C3D4',
                  inputType: 'text',
               },
               {
                  field: 'lineText',
                  key: 'TEXT',
                  fullName: 'Text 996',
                  placeHolder: 'QWE',
                  inputType: 'text',
               },
               {
                  field: 'unavailableTag',
                  key: 'UVD',
                  fullName: 'Unavailable Tag',
                  validationName: 'ALPHA_NUMERIC',
                  dataType: 'string',
                  characterLimit: 1,
                  placeHolder: 'A',
                  inputType: 'text',
               },
               {
                  field: 'transmissionDateTime',
                  key: 'REC DT',
                  fullName: 'Received Date',
                  validationName: 'DATE_STRING',
                  dataType: 'string',
                  placeHolder: '01JAN25',
                  inputType: 'text',
               },
            ],
         },
      ],
   },
];

export default rulesSearchCriteria;
